/**
 * @license
 * @qwik.dev/core 2.0.0-beta.45-dev+3a18bed
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ve, isBrowser as ze } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { getAsyncLocalStorage as Be } from "@qwik.dev/core/async-local-storage";

export { getAsyncLocalStorage as _getAsyncLocalStorage } from "@qwik.dev/core/async-local-storage";

import { p as We } from "@qwik.dev/core/preloader";

const Ue = !1;

const He = (t, ...n) => Ye(!1, t, ...n);

const Je = (t, ...n) => Ye(!0, t, ...n);

const Ye = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

const Ge = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Ze = t => typeof t === "object" && t !== null;

const Ke = t => Array.isArray(t);

const tr = t => typeof t === "string";

const nr = t => typeof t === "function";

const er = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = Ye(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const rr = "2.0.0-beta.45-dev+3a18bed";

const ir = "<sync>";

const sr = t => typeof t === "function" && typeof t.getSymbol === "function";

const Od = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const or = "q:renderFn";

const lr = "q:componentHash";

const ur = "q:targetEl";

const cr = "⚡️";

const fr = "q:slot";

const ar = "q:sparent";

const hr = "q:s";

const dr = "[q\\:patch]";

const pr = "q:r";

const Ld = "q:rp";

const $r = "q:cc";

const yr = "q:style";

const wr = "style[q\\:style]";

const vr = wr + ",style[q\\:sstyle]";

const mr = "q:sstyle";

const br = "q:ctx";

const _r = "q:brefs";

const gr = (t, n) => t["qFuncs_" + n] || [];

const Er = "q:base";

const Sr = "q:container-island";

const kr = "/" + Sr;

const Rr = "q:ignore";

const Pr = "/" + Rr;

const Tr = "q:container";

const Ar = "/" + Tr;

const qr = "q:template";

const Ir = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const Mr = "http://www.w3.org/1999/xhtml";

const xr = "http://www.w3.org/2000/svg";

const Nr = "http://www.w3.org/1998/Math/MathML";

const Cr = "qRender";

const Or = "q-e:qvisible";

const jr = "q:id";

const Lr = "q:key";

const Fr = "q:props";

const Xr = "q:seq";

const Dr = "q:seqIdx";

const Wr = "q:p";

const Vr = "q:ps";

const Ur = ":on";

const Br = ":onIdx";

const Qr = ":onFlags";

const Hr = ":cursorBoundary";

const Jr = ":nearestCursorBoundary";

const Yr = ":";

const Gr = "dangerouslySetInnerHTML";

const Kr = () => ({
    isServer: Ve,
    importSymbol(t, n, e) {
        if (Ve) {
            const t = Od(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw er(6, [ e ]);
        }
        if (!n) {
            throw er(14, [ e ]);
        }
        if (!t) {
            throw er(13, [ n, e ]);
        }
        const s = ti(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const ti = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(Er) ?? s, s);
    return new URL(e, o);
};

let ni = /*#__PURE__ */ Kr();

const ei = t => ni = t;

const ri = () => ni;

const jd = () => ni.isServer;

/*@__INLINE__*/ const ii = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const si = (t, n, e, s, o = !1) => {
    const r = ii(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const oi = (t, n, e) => {
    const s = ii(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const li = (t, n, e) => ii(t, n, e) >= 0;

const ui = t => t.nodeType === 1;

const ci = 100;

const fi = t => {
    try {
        return !!t && typeof t == "object" && typeof t.then === "function";
    } catch {
        return !1;
    }
};

const ai = (t, n, e) => {
    try {
        const s = t();
        return fi(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const hi = (t, n) => fi(t) ? t.then(n) : n(t);

const di = t => new Promise(n => {
    setTimeout(n, t);
});

const pi = t => {
    throw t;
};

function t(t, n = pi) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!fi(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = ci;
    const r = async e => {
        for (;fi(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!fi(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const $i = t => {
    const n = t.pn;
    return n || t;
};

const Fd = t => t.It;

const yi = Symbol();

class wi {
    [yi]=void 0;
}

const vi = "q:type";

const mi = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const gi = 124;

const Ei = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

const Si = t => t === "foreignObject";

const ki = t => t === "svg" || Si(t);

const Ri = t => t === "math";

function n(t, e, s, o = !1) {
    const r = t.ownerDocument.createElementNS(s, e);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== Yr && r.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let e = 0; e < t.childNodes.length; e++) {
            const i = t.childNodes[e];
            const c = i.nodeType;
            c === 3 ? r.appendChild(i.cloneNode()) : c === 1 && r.appendChild(n(i, i.localName, s, o));
        }
    }
    return r;
}

const Pi = {
    elementNamespace: Mr,
    elementNamespaceFlag: 0
};

function e(t, n) {
    const e = !t || !!Yl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Si(Yl(t));
    let o = Mr;
    let r = 0;
    const i = typeof n === "string" || wl(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return ki(t);
        }
        if (wl(t)) {
            return ki(Yl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = xr;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Ri(t);
        }
        if (wl(t)) {
            return Ri(Yl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Nr;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? xr : e ? Nr : Mr;
        r = t.flags & 1536;
    }
    Pi.elementNamespace = o;
    Pi.elementNamespaceFlag = r;
    return Pi;
}

const Ti = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function r(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + Ai(t.slice(s, -1));
        }
    }
    return null;
}

const Ai = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = qi(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const qi = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const Ii = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

class Mi {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [yi]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class xi extends Mi {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class Ni extends xi {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class Ci extends Mi {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const Oi = [];

const ji = [];

function i(t, n) {
    const e = $(n).priority;
    let s = Oi.length;
    for (let t = 0; t < Oi.length; t++) {
        const n = $(Oi[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Oi.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function s() {
    for (let t = 0; t < Oi.length; t++) {
        const n = Oi[t];
        let e = !1;
        for (let t = 0; t < ji.length; t++) {
            const s = ji[t];
            if (vu(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function o(t, n) {
    ji.push(t);
    c(t, n, !0);
    n.o++;
}

function l(t, n) {
    f(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    i(n, t);
}

function u(t, n, e) {
    const s = $(e);
    if (!s || s === n) {
        return;
    }
    c(e, t, !1);
    f(e, t);
    p(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function c(t, n, e) {
    e || (t.flags &= -257);
    const s = Oi.indexOf(t);
    if (s !== -1) {
        Oi.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function f(t, n) {
    const e = ji.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = ji.length - 1;
    e !== s && (ji[e] = ji[s]);
    ji.pop();
    n.o--;
    return !0;
}

const Li = new WeakMap;

const Fi = ":nodeProps";

const Xi = ":nodeDiff";

const Di = ":errorData";

const Wi = ":signal";

const Vi = ":inlineComponentData";

const zi = new WeakMap;

function a(t, n) {
    let e = zi.get(t);
    e || zi.set(t, e = []);
    e.includes(n) || e.push(n);
}

function h(t) {
    const n = zi.get(t);
    n && zi.delete(t);
    return n;
}

function d(t, n, e) {
    n.position = e;
    e && $n(e) && function s(t, n, e) {
        const s = $(e);
        if (!s || s === n) {
            return;
        }
        c(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = h(n);
            if (s) {
                for (let n = 0; n < s.length; n++) {
                    a(t, s[n]);
                }
            }
            const o = n.extraPromises;
            if (o && o.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...o) : t.extraPromises = o;
            }
            p(t, n);
        })(n, s);
    }(t, n, e);
}

function p(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.pendingBoundary && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function $(t) {
    return Li.get(t) ?? null;
}

const Ui = Symbol();

const Bi = Symbol();

const Qi = Symbol();

const Hi = Symbol();

const Ji = Symbol();

const Yi = Symbol();

const Gi = [];

const Zi = {};

Object.freeze(Gi);

Object.freeze(Zi);

function y(t) {
    return new Proxy({}, new Ki(t));
}

class Ki {
    owner;
    ft=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Ui) {
            return this.owner.constProps;
        }
        if (n === Bi) {
            return this.owner.varProps;
        }
        if (n === Qi) {
            return this.owner;
        }
        if (n === Hi) {
            return this;
        }
        let e;
        if (n === "children") {
            e = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            e = es(this.owner, n);
            n in this.owner.varProps && ts(this, n);
        }
        return e instanceof Xs ? e.value : e;
    }
    set(t, n, e) {
        if (n === Qi) {
            this.owner = e;
        } else if (n === "children") {
            this.owner.children = e;
        } else if (n === Ui) {
            this.owner.constProps = e;
        } else if (n === Bi) {
            this.owner.varProps = e;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Zi ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== e) {
                this.owner.varProps[n] = e;
                ns(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ns(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Ui || n === Bi) {
            return !0;
        }
        const e = n in this.owner.varProps;
        if (typeof n === "string") {
            e && ts(this, n);
            if (typeof this.owner.type === "string") {
                const t = r(n);
                t && (n = t);
            }
        }
        return e || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const ts = (t, n) => {
    const e = na();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.an;
    s && Cn(t.owner._proxy, n, t, s);
};

const ns = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ft, n);
    e && ju(t.$, t, e);
    return !!e;
};

const es = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const rs = (t, n) => is(t)?.[n] || ss(t)?.[n] || null;

const is = t => {
    if (!t) {
        return null;
    }
    return Bi in t ? "children" in t ? {
        ...t[Bi],
        children: t.children
    } : t[Bi] : t;
};

const ss = t => {
    if (!t) {
        return null;
    }
    return Ui in t ? t[Ui] : null;
};

const os = t => t && Bi in t;

const ls = Symbol();

class us {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const cs = Symbol();

const fs = Symbol();

const as = Symbol();

function w(t, n, e) {
    t[yi] || (Ve && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(_r, new Map) : t[yi] = new Map);
    const o = t[yi];
    let r = o.get(n);
    if (!r) {
        r = new us(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const hs = (t, n) => (e, s) => {
    const o = Xe();
    o.an = w(t, ":");
    o.$ = n || void 0;
    return je(o, () => {
        if (nr(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Mu(e)) {
            return e.value;
        }
        if (Ze(e) && Hu(e)) {
            Cn(zu(e), as, Vu(e), o.an);
            return e;
        }
        throw er(2);
    });
};

const ds = /*#__PURE__*/ new WeakMap;

const ps = t => {
    for (let n = 0; n < 8; n++) {
        if (typeof t !== "object" || t === null) {
            return;
        }
        if (ds.has(t)) {
            return t;
        }
        try {
            t = t.cause;
        } catch {
            return;
        }
    }
    return;
};

const $s = t => {
    const n = ps(t);
    const e = n && ds.get(n);
    return e && e.Wt === n ? e : void 0;
};

class ys {
    Xt;
    ft=void 0;
    $=null;
    $n=null;
    constructor(t, n) {
        this.$ = t || na()?.$ || null;
        this.Xt = n;
    }
    trigger() {
        ju(this.$, this, this.ft);
    }
    force() {
        ju(this.$, this, this.ft);
    }
    get untrackedValue() {
        return this.Xt;
    }
    set untrackedValue(t) {
        this.Xt = t;
    }
    get value() {
        const t = this.untrackedValue;
        this.yn();
        return t;
    }
    yn() {
        const t = na();
        if (!t) {
            return;
        }
        this.$ === null && (this.$ = t.$);
        const n = t.an;
        if (n) {
            const e = Ve;
            const s = this.ft ||= new Set;
            const o = __EXPERIMENTAL__.pendingBoundary && e;
            xu(s, n);
            Nu(n, this);
            if (e) {
                const e = Ou(t.$, this.$);
                o && e?.wn?.(this, n, null);
                Cu(n, e);
            }
        }
    }
    set value(t) {
        if (t !== this.Xt) {
            this.Xt = t;
            ju(this.$, this, this.ft);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Xt
        };
    }
}

class ws {
    vn;
    mn=null;
    bn=!1;
    _n=!0;
    constructor(t, n, e) {
        this.vn = t;
        if (n !== void 0) {
            this.info = n;
            this.gn = e;
        }
    }
    get track() {
        if (!this.En) {
            const t = hs(this.vn, this.vn.$);
            this.En = (n, e) => {
                if (this.vn.Sn) {
                    throw er(39);
                }
                return t(n, e);
            };
        }
        return this.En;
    }
    get abortSignal() {
        const t = this.kn ||= new AbortController;
        this.bn && t.abort();
        return t.signal;
    }
    cache() {}
    get previous() {
        const t = this.vn.Xt;
        if (t !== ls) {
            return t;
        }
    }
    cleanup=t => {
        typeof t === "function" && (this.Rn ||= []).push(t);
    };
}

class vs extends ys {
    Dt;
    h;
    [yi]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || na()?.$, ls);
        this.Dt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.Xt = typeof o === "function" ? o() : o);
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.zt = r;
            this.Ut = [];
        }
        s.timeout && (this.Bt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
    }
    clear() {
        this.Xt = ls;
        this.invalidate();
    }
    invalidate(t) {
        if (this.Sn) {
            return;
        }
        if (arguments.length > 0) {
            this.Pn = t;
            this.gn = this.gn === void 0 ? 1 : this.gn + 1;
        }
        const n = $s(this.Wt ?? sa(() => gs(this)));
        n === this ? this.Xt === ls && Es(this) : n && !n.Tn?.mn && n.invalidate();
        this.An();
    }
    An() {
        if (this.Sn) {
            return;
        }
        if (this.h & 512) {
            this.qn(!0);
            return;
        }
        this.h |= 1;
        const n = Xe();
        n.$ = this.$ || void 0;
        const e = t(Le.bind(this, n, this.p));
        fi(e) && e.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        try {
            return super.value;
        } catch (t) {
            !fi(t) && na()?.an?.consumer instanceof vs && this.yn();
            throw t;
        }
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.Pn = void 0;
            if (this.Ut) {
                for (let t = 0; t < this.Ut.length; t++) {
                    this.Ut[t]._n = !1;
                }
            } else {
                this.Tn && (this.Tn._n = !1);
            }
            super.value = t;
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.Tn?.mn) {
            if (this.Xt === ls || Ve) {
                throw this.Tn?.mn;
            }
            return this.Xt;
        }
        if (this.Wt && this.Xt === ls) {
            throw this.Wt;
        }
        if (Ve && this.h & 64 && this.Xt === ls) {
            throw er(35);
        }
        return this.Xt;
    }
    set untrackedValue(t) {
        this.Xt = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = na();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.an;
            if (t) {
                xu(this.yt ||= new Set, t);
                Nu(t, this);
                Cu(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Vt) {
            this.Vt = t;
            ju(this.$, this, this.yt);
        }
    }
    get untrackedPending() {
        this.p();
        if (Ve && this.Tn?.mn) {
            throw this.Tn?.mn;
        }
        return !!this.Vt;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        this.In();
        if (t || this.Xt === ls) {
            return t;
        }
        return gs(this);
    }
    In() {
        const t = na();
        if (t && (this.$ ||= t.$ || null)) {
            const n = t.an;
            if (n) {
                xu(this.wt ||= new Set, n);
                Nu(n, this);
                Cu(n, this.$);
            }
        }
    }
    set untrackedError(t) {
        if (t !== this.Wt) {
            this.Wt = t;
            ju(this.$, this, this.wt);
        }
    }
    get untrackedError() {
        this.p();
        if (Ve && this.Tn?.mn) {
            throw this.Tn?.mn;
        }
        return this.Xt === ls ? void 0 : this.Wt;
    }
    qn(t) {
        if (this.Sn) {
            return;
        }
        this.h |= 1;
        t && (this.ft?.size || this.yt?.size || this.wt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.Tn && this.Mn(this.Tn, t);
    }
    vt() {
        if (!(this.h & 32) || this.xn()) {
            return;
        }
        if (!ze) {
            return;
        }
        setTimeout(() => {
            this.xn() || this.abort();
        });
    }
    async promise() {
        await t(() => this.p());
        for (;this.Tn?.mn; ) {
            await (this.Tn?.mn);
        }
    }
    p() {
        if (this.Sn || !(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.Nn();
        }
        const n = this.Dt;
        Iu(n);
        const e = this.Tn;
        if (e && !e.bn) {
            e.bn = !0;
            e.kn?.abort();
            this.Cn(e);
        }
        const s = new ws(this, this.Pn, this.gn);
        this.Tn = s;
        const o = this.On();
        let r;
        try {
            r = this.jn(n.resolved, s);
        } catch (t) {
            if (fi(t)) {
                throw t;
            }
            s.gn === this.gn && (this.Pn = void 0);
            this.h &= -2;
            this.Ln(s, t);
            this.Fn(o);
            return;
        }
        if (fi(r)) {
            this.h |= 512;
            this.h &= -2;
            let n = r;
            const e = () => {
                const t = n ?? this.jn(this.Dt.resolved, s);
                n = void 0;
                return t;
            };
            s.mn = this.Xn(s, () => t(e), o);
            return;
        }
        s.gn === this.gn && (this.Pn = void 0);
        this.h &= -2;
        this.Dn(r);
        this.Fn(o);
    }
    Dn(t) {
        const n = t !== this.Xt;
        this.Xt = t;
        this.untrackedError = void 0;
        n && ju(this.$, this, this.ft);
    }
    On() {
        return this.wt?.size ? bs(this) : void 0;
    }
    Fn(t) {
        if (!t) {
            return;
        }
        const n = bs(this);
        (n.size !== t.size || Array.from(t).some(t => !n.has(t))) && ju(this.$, this, this.wt);
    }
    jn(t, n) {
        if (this.Sn) {
            throw er(39);
        }
        const e = t;
        if (this.h & 1024) {
            let t = na();
            t?.an && (t = {
                ...t,
                an: void 0
            });
            return Le(t, e, [ n ]);
        }
        const s = this.$ ||= na()?.$ || null;
        const o = w(this, ".");
        s && Tn(s, o);
        const r = Xe();
        r.$ = s || void 0;
        r.an = o;
        return Le(r, e, [ n ]);
    }
    Nn() {
        if (Ve && this.h & 64) {
            this.Vt = !0;
            this.$?.serializationCtx.xe.add(this);
            return;
        }
        this.h &= -2;
        const t = this.Tn;
        t && this.Mn(t);
        const n = this.zt === 0 ? Infinity : this.zt ?? 1;
        if (this.Ut ? this.Ut.length >= n : t?.mn) {
            this.h |= 1;
            return;
        }
        const e = this.gn;
        const s = new ws(this, this.Pn, e);
        this.Tn = s;
        this.Ut && this.Ut.push(s);
        s.mn = this.Wn(s);
    }
    async Wn(n) {
        let e = this.Dt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Dt.resolve();
            if (this.Sn || n.kn?.signal.aborted) {
                n.mn = null;
                return;
            }
        }
        this.Bt && (this.Vn = setTimeout(() => {
            const t = Error(`timeout ${this.Bt}ms`);
            this.Ln(n, t);
            n.kn?.abort(t);
        }, this.Bt));
        return this.Xn(n, () => t(() => this.jn(e, n)), this.On());
    }
    async Xn(t, n, e) {
        try {
            const e = n();
            let s;
            if (fi(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.mn = null;
            if (t._n) {
                const n = this.Ut;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s]._n = !1);
                    }
                }
                this.Dn(s);
            }
        } catch (n) {
            t.mn = null;
            this.Ln(t, n);
        }
        if ((() => t === this.Tn)() && !this.Sn) {
            clearTimeout(this.Vn);
            t.gn === this.gn && (this.Pn = void 0);
            this.Fn(e);
            this.h & 1 ? this.p() : this.untrackedPending = !1;
        }
    }
    Ln(t, n) {
        if (t !== this.Tn || !t._n) {
            return;
        }
        t._n = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        Ve || $s(n) || ((t, n) => {
            typeof t === "object" && t !== null && ds.set(t, n);
        })(n, this);
        this.untrackedError = n;
    }
    $dispose() {
        if (this.Sn) {
            return;
        }
        this.Sn = !0;
        this.h &= -2;
        clearTimeout(this.Vn);
        this.$ && Pn(this.$, this);
        const t = new Set(this.Ut);
        this.Tn && t.add(this.Tn);
        for (const n of t) {
            n._n = !1;
            this.Mn(n);
        }
    }
    async zn() {
        clearTimeout(this.Vn);
        const t = this.Tn;
        t && this.Mn(t);
        this.Ut ? await Promise.all(this.Ut.map(t => t.mn)) : await (t?.mn);
    }
    xn() {
        return !!(this.ft?.size || this.yt?.size || this.wt?.size);
    }
    Mn(t, n) {
        if (t.bn) {
            return;
        }
        t.bn = !0;
        t.kn?.abort(n);
        t.mn = hi(t.mn, () => this.Un(t));
    }
    Cn(t) {
        const n = t.Rn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    fi(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Un(t) {
        const n = () => {
            t.mn = null;
            const n = this.Ut;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.Cn(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const ms = (t, n) => {
    const e = t[yi];
    if (!e) {
        return !1;
    }
    for (const t of e.values()) {
        if (!t.backRef) {
            continue;
        }
        const e = Array.from(t.backRef);
        for (let s = 0; s < e.length; s++) {
            const o = e[s];
            if (o instanceof ys && o.ft?.has(t) && n(o)) {
                return !0;
            }
        }
    }
    return !1;
};

const bs = t => {
    const n = new Set;
    ms(t, t => {
        (t instanceof vs || t[yi]) && n.add(t);
        return !1;
    });
    return n;
};

const _s = (t, n, e) => ms(t, t => {
    if (n.has(t)) {
        return !1;
    }
    n.add(t);
    return t instanceof vs && e(t) || _s(t, n, e);
});

const gs = t => {
    let n;
    _s(t, new Set([ t ]), t => {
        t.In();
        n = t.Wt;
        return !!n;
    });
    return n;
};

const Es = t => {
    const n = e => {
        if (!e) {
            return;
        }
        for (const {consumer: s} of e) {
            if (s instanceof vs && $s(s.Wt) === t) {
                s.qn(!1);
                n(s.ft);
                n(s.wt);
            }
        }
    };
    n(t.ft);
    n(t.wt);
};

const Ss = t => (n, ...e) => t.call(null, Oa(n), ...e);

class ks extends vs {
    constructor(t, n) {
        super(t, n, 17);
    }
    Bn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Iu(this.Dt);
        const t = sa(this.Dt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Xt === ls ? e : this.Xt;
        const r = la(() => this.Bn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Bn = !0;
        this.h &= -2;
        const i = this.Bn && r !== "undefined" || r !== this.Xt;
        if (i) {
            this.Xt = r;
            ju(this.$, this, this.ft);
        }
    }
}

class Rs extends vs {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const Ps = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Ts = (t, n) => new vs(n?.container || null, t, Fu(n?.serializationStrategy || "always"), n);

const As = (t, n) => new Rs(n?.container || null, t, Fu(n?.serializationStrategy || "always"), n);

const qs = t => new ks(null, t);

const Is = t => new ys(null, t);

const Ms = /*#__PURE__*/ Ss(Ts);

const xs = Ss(qs);

const Ns = t => t.value;

const Cs = (t, n) => t[n];

const Os = t => {
    if (t.length === 1) {
        if (Mu(t[0])) {
            return t[0].$n ||= new Xs(null, Ns, t, null);
        }
        if (Hu(t[0])) {
            return new Xs(null, Ns, t, null);
        }
        return t[0].value;
    }
    return new Xs(null, Cs, t, null);
};

const js = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Ze(n)) {
        return n[e];
    }
    if (Mu(n)) {
        if (n instanceof Xs) {
            return n;
        }
        return Os(t);
    }
    if (os(n)) {
        const s = n[Ui];
        const o = n[Bi];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Ls(n, t);
        }
    } else {
        const s = zu(n);
        if (s) {
            const n = s[e];
            return Ls(n, t);
        }
    }
    return n[e];
};

const Ls = (t, n) => Mu(t) ? t : Os(n);

const Fs = (t, n) => {
    const e = js(t, n);
    if (e === Ji) {
        return t[n];
    }
    return e;
};

class Xs extends ys {
    ut;
    lt;
    Rt;
    h;
    _=void 0;
    [yi]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, ls);
        this.ut = e;
        this.lt = n;
        this.Rt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this._) {
                this.$.setHostProp(this._, Wi, this);
                vn(this.$, this._, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            ju(this.$, this, this.ft);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Xt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = la(() => this.lt(...this.ut), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.Xt;
        if (n) {
            this.h |= 2;
            this.Xt = t;
        }
    }
    st() {
        return this.lt === Ns && Mu(this.ut[0]) ? this.ut[0] : this;
    }
    set value(t) {
        throw er(31);
    }
    get value() {
        return super.value;
    }
}

class Ds {
    data;
    constructor(t) {
        this.data = t;
    }
}

const Ws = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

Object.prototype.hasOwnProperty;

class Vs {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Ws(n) ? Zi : n;
        this.constProps = !e || Ws(e) ? null : e;
    }
    get props() {
        return this._proxy ||= y(this);
    }
}

const zs = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Us = t => t instanceof Vs;

const Bs = (t, n, e) => {
    if (typeof t === "string") {
        const s = Ie(n);
        return Gf(s, () => {
            Ea(Sa(s, t));
            return e();
        });
    }
    return e();
};

function v(t, n) {
    return Bs(this, n, () => {
        const t = ga[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function m(t, n) {
    return Bs(this, n, () => {
        const t = ga[0];
        t.value = n.checked;
    });
}

function b(t, n) {
    return Bs(this, n, () => {
        if (ga) {
            for (let t = 0; t < ga.length; t++) {
                const n = ga[t];
                n instanceof Rs && n.h & 64 && n.p();
            }
        }
    });
}

const Qs = "bind:value";

const Hs = "bind:checked";

const Js = "passive:";

const Ys = "preventdefault:";

const Gs = Object.prototype.hasOwnProperty;

const Zs = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(Ai(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const Ks = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return Ai(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return Ai(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return Ai(t.slice(11, -1));
    }
    return null;
};

const to = (t, n, e, s, o = !1) => {
    let i = t;
    let c = o;
    for (let t = 0; t < n.length; t++) {
        const o = n[t];
        const l = Ks(o);
        const u = r(o, s.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = e.get(u);
            (t === void 0 || t < e.get(o)) && (i[u] = i[o]);
            delete i[o];
        }
    }
    return i;
};

const no = (t, n, e, s, o, r, i) => new Vs(t, n, e, s, o, r, !1, i);

const eo = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(Js)) {
                    r.push(o);
                    t.add(Ai(o.slice(8)));
                } else {
                    o.startsWith(Ys) ? h.push(o) : Ks(o) !== null ? s.push(o) : o === Hs ? a = e[o] : o === Qs && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(Js)) {
                    i.push(s);
                    t.add(Ai(s.slice(8)));
                } else {
                    s.startsWith(Ys) ? d.push(s) : Ks(s) !== null ? o.push(s) : s === Hs ? a = n[s] : s === Qs && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = Zs(e, r, h, t, l);
            l = l || e !== n;
            e = to(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = Zs(n, i, d, t, u);
            u = u || n !== e;
            n = to(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && Gs.call(n, Hs) && delete n[Hs];
                if (e && Gs.call(e, Hs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Hs];
                }
                n.checked = a;
                const t = Ta(null, "_chk", m, null, [ a ]);
                if (e && Gs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = zs(n, "q-e:input", t) || c;
                }
                c = zs(n, "q-e:input", t) || c;
            } else if (f) {
                n && Gs.call(n, Qs) && delete n[Qs];
                if (e && Gs.call(e, Qs)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[Qs];
                }
                n.value = f;
                const t = Ta(null, "_val", v, null, [ f ]);
                if (e && Gs.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = zs(n, "q-e:input", t) || c;
                }
                c = zs(n, "q-e:input", t) || c;
            }
        }
        if (n && Gs.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && Gs.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Vs(t, n, e, s, o, r, c || !0, i);
};

const ro = (t, n, e, s) => lo(t, n, s);

const io = (t, n, e, s, o) => lo(t, {
    ...e,
    ...n
}, o);

const so = (t, n, e, s, o, r) => lo(t, {
    ...e,
    ...n,
    children: s
}, r);

const oo = t => t.children;

const lo = (t, n, e, s, o) => eo(t, n, null, null, 0, e, o);

const uo = lo;

const co = lo;

function _(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return eo(t, n, null, s.children, 0, o);
}

const fo = t => t.children;

const ao = (t, n) => new Vs(oo, null, null, t.children, 0, n);

const ho = t => no(oo, null, {
    [hr]: ""
}, t.children, 0, t.name ?? "");

const po = Symbol();

const $o = () => null;

const yo = () => null;

const wo = t => t.children;

const vo = (t, n) => lo(ao, {
    children: lo(mo, t)
}, n);

const mo = () => null;

let bo = null;

let _o = null;

function g(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    _o || (_o = t.setAttributeNS);
                    _o.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            bo || (bo = t.setAttribute);
            bo.call(t, n, e);
        })(t, n, e);
    }
}

function E(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const go = Object.prototype.hasOwnProperty;

const Eo = Object.prototype.propertyIsEnumerable;

function S(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

function k(t) {
    if (t) {
        for (const n in t) {
            if (S(n)) {
                return !0;
            }
        }
    }
    return !1;
}

const So = (t, n = [], e = {}) => {
    if (!Ze(t) || !os(t)) {
        if (t == null) {
            throw new TypeError(`Cannot destructure '${t}' as it is ${t}.`);
        }
        const s = Object(t);
        const o = Reflect.ownKeys(s);
        for (let t = 0; t < o.length; t++) {
            const r = o[t];
            !Eo.call(s, r) || typeof r !== "symbol" && n.includes(r) || Object.defineProperty(e, r, {
                value: s[r],
                enumerable: !0,
                configurable: !0,
                writable: !0
            });
        }
        return e;
    }
    let s = null;
    const o = t[Ui];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Bi];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return y(new Vs(null, r, s, null, 0, null));
};

function R(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && go.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Xs) {
            return ua(n, t, ":", e);
        }
    }
    return es(n, "name") || "";
}

const ko = t => cr + t;

const Ro = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + ko(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Po = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const To = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Ao = t => {
    if (!t) {
        return "";
    }
    if (tr(t)) {
        return t.trim();
    }
    const n = [];
    if (Ke(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Ao(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const qo = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const Io = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Ke(t)) {
            throw er(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(qo(e) + ":" + xo(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

const Mo = t => t != null ? t + "" : null;

function P(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Ao(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = Io(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = Mo(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const xo = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => Po.has(t))(t)) {
        return n + "px";
    }
    return n;
};

class No {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Co {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Oo {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class jo {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Lo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Fo = t => new No(t);

const Xo = t => new Co(t);

const Do = (t, n) => new Oo(t, n);

const Wo = (t, n, e) => new jo(t, n, e);

const Vo = (t, n, e, s = null, o = !1) => new Lo(t, n, e, s, o);

const zo = () => {
    const t = ra();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Xr);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Xr, s);
    }
    let o = t.$.getHostProp(e, Dr);
    o === null && (o = 0);
    t.$.setHostProp(e, Dr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Uo = t => {
    const n = nr(t) && !Wa(t) ? je(void 0, t) : t;
    return Is(n);
};

const Bo = t => Qo(Uo, t);

const Qo = (t, ...n) => {
    const {val: e, set: s} = zo();
    if (e != null) {
        return e;
    }
    t = nr(t) && !Wa(t) ? sa(t, ...n) : t;
    return s(t);
};

function T(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    let e = null;
    let s = n;
    for (;s && !e; ) {
        e = I(s);
        s = s.slotParent || s.parent;
    }
    if (!e) {
        return;
    }
    const o = t.boundaries ||= [];
    if (!o.includes(e)) {
        o.push(e);
        e.value++;
    }
}

function A(t) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return null;
    }
    return El(t, Hr, null) || null;
}

function q(t) {
    M(t, null);
}

function I(t) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return null;
    }
    return El(t, Jr, null) || A(t);
}

function M(t, n) {
    __EXPERIMENTAL__.pendingBoundary && Sl(t, Jr, n);
}

function x(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    M(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        x(s, A(s) || n);
    }
}

const Ho = t => {
    if (t.zn) {
        try {
            t.zn();
        } catch (t) {
            He(t);
        }
        t.zn = null;
    }
};

function N(n, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const t = Ie(s);
        return Gf(t, () => N(n, e, s, ia(e, s, t)));
    }
    const r = o.$;
    const i = o._;
    Tl(r, i);
    let c = n;
    if (i.flags & 64) {
        let t;
        if (!(i.flags & 128)) {
            t = !0;
            i.flags |= 128;
        }
        const o = t ? r.k : null;
        const l = El(i, Wr, o);
        if (l !== null) {
            c = () => n(e, s, l);
        } else {
            const t = El(i, Vr, o);
            t !== null && (c = () => n(e, s, ...t));
        }
    }
    return t(() => {
        if (!(i.flags & 32)) {
            return Le(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i, "event"));
}

function C(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Ie(n);
    return Gf(e, () => {
        const s = ia(t, n, e);
        typeof this === "string" && Ea(Sa(s.$, this));
        const o = ga[0];
        return N(o, t, n, s);
    });
}

function O(t) {
    return t.R === t.T ? t.q : null;
}

function j(t) {
    return t.M || O(t);
}

function L(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = O(t);
    return e === o ? null : e;
}

const Jo = Object.prototype.hasOwnProperty;

function F(t, n, e, s, o, r) {
    Sl(n, e, r);
    mn(t, Vo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function X(t, n, e, s) {
    return {
        $: t,
        N: n,
        O: e,
        j: s,
        L: [],
        X: [],
        D: [],
        R: null,
        M: null,
        W: null,
        q: null,
        T: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: 0,
        Z: 0,
        K: !0,
        tt: !1,
        nt: {
            et: new Ds({
                j: s,
                rt: !0
            }),
            it: new Ds({
                j: s,
                rt: !1
            })
        }
    };
}

function D(t, n, e, s, o) {
    const r = t ?? X(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.$ = n;
        t.N = e;
        t.O = s;
        t.j = o;
        t.nt.et.data.j = o;
        t.nt.it.data.j = o;
        t.X.length = 0;
        t.D.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Yo = (t, n, e, s, o, r, i) => W(D(i, t, n, o, r), e, s);

const Go = (t, n, e, s, o, r, i, c, l = !1, u) => W(D(u, t, n, i, c), e, s, o, r, l);

function W(t, n, e, s = Kl(e), o = null, r = !1) {
    V(t, n, e, s, o, r);
    const i = K(t);
    if (fi(i)) {
        return i.finally(() => {
            tt(t);
        });
    }
    tt(t);
}

function V(t, n, e, s = Kl(e), o = null, r = !1) {
    const i = t.tt;
    t.tt = r || i;
    t.R = e;
    t.W = null;
    t.M = s;
    t.q = o;
    t.T = e;
    H(t, n, !0);
    try {
        if (t.R.flags & 32) {
            return;
        }
        for (;t.L.length; ) {
            for (;t.G < t.Z; ) {
                if (typeof t.Y === "string") {
                    mt(t, t.Y);
                } else if (typeof t.Y === "number") {
                    mt(t, t.Y + "");
                } else if (t.Y && typeof t.Y === "object") {
                    if (Us(t.Y)) {
                        const n = t.Y.type;
                        if (typeof n === "string") {
                            rt(t);
                            at(t, t.Y, n);
                            const e = t.Y.constProps && Jo.call(t.Y.constProps, Gr) || Jo.call(t.Y.varProps, Gr);
                            e ? t.W || nt(t, !1) : B(t, t.Y.children, !0);
                        } else if (typeof n === "function") {
                            if (n === fo) {
                                rt(t);
                                $t(t, "F", t.Y.key);
                                B(t, t.Y.children, !0);
                            } else if (n === ho) {
                                rt(t);
                                G(t) || B(t, t.Y.children, !0);
                            } else if (n === gt) {
                                Y(t);
                                B(t, t.Y.children, !0, !0);
                            } else if (n === yo) {
                                et(t);
                            } else if (n === $o) {
                                et(t);
                            } else {
                                rt(t);
                                yt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Y)) {
                        B(t, t.Y, !1);
                    } else if (Mu(t.Y)) {
                        $t(t, "S", null);
                        const n = t.Y instanceof Xs ? t.Y.st() : t.Y;
                        const e = t.M?.[yi]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Xs && (s = Nt(e, n));
                        if (!s) {
                            const e = t.W || t.M;
                            B(t, z(t, () => ua(n, e, ".", t.$)), !0);
                        }
                    } else if (fi(t.Y)) {
                        $t(t, "A", null);
                        t.X.push(t.Y, t.W || t.M);
                    }
                } else {
                    t.Y === po || mt(t, "");
                }
                U(t);
            }
            et(t);
            Z(t);
            Q(t);
        }
    } finally {
        t.tt = i;
    }
}

function z(n, e) {
    try {
        return e();
    } catch (s) {
        if (fi(s)) {
            const o = s.then(() => t(e));
            n.X.push(o, n.W || n.M);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.K) {
        t.K = !0;
        return;
    }
    t.G++;
    if (t.G < t.Z) {
        t.Y = t.J[t.G];
    } else if (t.L.length > 0 && t.L[t.L.length - 1] === !1) {
        return Q(t);
    }
    t.W !== null ? t.W = null : t.M = L(t, t.M);
}

function B(t, n, e, s = !1) {
    if (!s && (n == null || e && Ke(n) && n.length === 0)) {
        nt(t);
        return;
    }
    H(t, n, e);
    if (e) {
        const n = !s && t.tt || !!t.W || !Kl(t.M);
        t.tt = n;
        t.H = null;
        t.U = null;
        t.B = null;
        t.R = t.W || t.M;
        t.M = Kl(t.R);
        t.W = null;
    }
    t.K = !1;
}

function Q(t) {
    const n = t.L.pop();
    if (n) {
        t.tt = t.L.pop();
        t.H = t.L.pop();
        t.U = t.L.pop();
        t.B = t.L.pop();
        t.W = t.L.pop();
        t.M = t.L.pop();
        t.R = t.L.pop();
    }
    t.Y = t.L.pop();
    t.Z = t.L.pop();
    t.G = t.L.pop();
    t.J = t.L.pop();
    U(t);
}

function H(t, n, e) {
    t.L.push(t.J, t.G, t.Z, t.Y);
    e && t.L.push(t.R, t.M, t.W, t.B, t.U, t.H, t.tt);
    t.L.push(e);
    if (Array.isArray(n)) {
        t.G = 0;
        t.Z = n.length;
        t.J = n;
        t.Y = t.Z > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.G = 0;
        t.Y = null;
        t.J = null;
        t.Z = 0;
    } else {
        t.G = 0;
        t.Y = n;
        t.J = null;
        t.Z = 1;
    }
}

function J(t) {
    if (t.W) {
        return j(t);
    }
    return L(t, t.M) || O(t);
}

function Y(t) {
    const n = t.Y;
    const e = n.key;
    t.M = El(t.R, e, n => Ml(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.W = $l();
        Sl(t.W, fr, e);
        t.W.slotParent = t.R;
        Sl(t.R, e, t.W);
    }
}

function G(t) {
    const n = t.Y;
    const e = Ru(t.R);
    const s = R(e, n, t.$);
    const o = es(n, Hr) || null;
    const r = e ? El(e, s, null) : null;
    if (r == null) {
        t.W = $l();
        Sl(t.W, fr, s);
        Sl(t.W, Hr, o);
        x(t.W, o);
        e && Sl(e, s, t.W);
        Ul(t.N, t.R, t.W, J(t));
        return !1;
    }
    if (r === t.M) {} else {
        const n = r.parent;
        t.W = r;
        Sl(t.W, fr, s);
        Sl(t.W, Hr, o);
        x(t.W, o);
        e && Sl(e, s, t.W);
        zl(t.N, t.W);
        Ul(t.N, t.R, t.W, J(t));
        n && wl(n) && !n.firstChild && Yl(n) === qr && Hl(t.N, n.parent, n, !0);
    }
    return !0;
}

function Z(t) {
    const n = t.H;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            kt(t.$, t.N, e, t.O);
            Hl(t.N, t.R, e, !0);
        }
        n.clear();
        t.H = null;
    }
    t.M = null;
}

function K(t) {
    for (;t.X.length; ) {
        const n = t.X.shift();
        const e = t.X.shift();
        if (fi(n)) {
            return n.then(n => {
                V(t, n, e);
                return K(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return K(t);
            });
        }
        V(t, n, e);
    }
    if (t.D.length) {
        const n = t.D.splice(0);
        return Promise.all(n).then(() => K(t));
    }
}

function tt(t) {
    t.N = null;
    t.O = null;
}

function nt(t, n = !0) {
    const e = t.M && Kl(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            kt(t.$, t.N, s, t.O);
            s = s.nextSibling;
        }
        Jl(t.N, t.M, e, n);
    }
}

function et(t) {
    const n = O(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = L(t, t.M);
            if (t.R === n.parent) {
                kt(t.$, t.N, n, t.O);
                Hl(t.N, t.R, n, !0);
            }
        }
    }
}

function rt(t) {
    if (t.M !== null && bl(t.M)) {
        const n = t.M;
        t.M = L(t, t.M);
        Hl(t.N, t.R, n, !0);
    }
}

function it(t, n, e) {
    if (Mu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw er(15, [ e ]);
}

function st(n, e, s, o, r) {
    return t(() => ua(o, e, s, n, r));
}

function ot(t, n, e, s, o) {
    const r = t.j;
    const i = s.then(t => g(n, e, P(e, t, r), o));
    t.D.push(i);
}

function lt(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Tr, "html");
    }
}

function ut(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ct(t, n, s, o) {
    const r = function i(t, n) {
        const s = Ql(t.R, !0);
        const o = e(s, n);
        const r = document;
        const i = o.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(o.elementNamespace, n);
        t.W = hl(i, n);
        t.W.flags |= o.elementNamespaceFlag;
        return i;
    }(t, s);
    const c = t.W;
    const l = (c.flags & 512) !== 0;
    const {constProps: u} = n;
    if (u) {
        for (const n in u) {
            let e = u[n];
            if (Ti(n)) {
                ft(n, e, r, c, t);
                continue;
            }
            if (n === "ref" && it(e, r, o)) {
                continue;
            }
            Mu(e) && (e = st(t.$, t.W, n, e, t.nt.et));
            if (fi(e)) {
                ot(t, r, n, e, l);
                continue;
            }
            if (n === Gr) {
                lt(r, e);
                continue;
            }
            if (s === "textarea" && n === "value" && ut(r, e)) {
                continue;
            }
            g(r, n, P(n, e, t.j), l);
        }
    }
    const f = n.key;
    f && (t.W.key = f);
    if (t.j) {
        const e = Jo.call(n.varProps, "class") || n.constProps && Jo.call(n.constProps, "class");
        e || r.setAttribute("class", t.j);
    }
    Fl(t.N, t.R, t.W, j(t));
}

function ft(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(N.bind(null, n));
                }
            } else {
                e && s.push(N.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = N.bind(null, n));
    }
    const i = r === "e:qvisible";
    (t.charAt(2) !== "e" || i) && kl(o.N, s, t, "");
    i || r === "d:qinit" || r === "d:qidle" ? a($(o.O), r) : Rl(o.$, r);
}

function at(t, n, e) {
    if (t.tt) {
        ct(t, n, e, null);
    } else {
        const s = t.M && wl(t.M);
        const o = s && e === Yl(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            dt(t, e, r);
        } else {
            const s = ht(e, r);
            pt(t, e, r, s, t.R) && ct(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.M;
    s && function r(t, n, e, s) {
        t.tt || Tl(t.$, n);
        const o = n.props;
        const r = (n.flags & 1536) === 0;
        for (const i in e) {
            const c = e[i];
            const l = o && r && !Jo.call(o, i) ? i.toLowerCase() : i;
            if (o && Jo.call(o, l)) {
                const e = o[l];
                if (l !== i) {
                    Sl(n, l, null);
                    Sl(n, i, e);
                }
                At(c, e) || Zo(t, n, i, c, s);
            } else {
                c != null && Zo(t, n, i, c, s);
            }
        }
        if (o) {
            for (const r in o) {
                Jo.call(e, r) || r.charAt(0) === ":" || Ti(r) || Zo(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Zo = (t, n, e, s, o) => {
    if (Ti(e)) {
        ft(e, s, n.node, n, t);
        return;
    }
    if (e === Wr || e === Vr) {
        Sl(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (it(s, t, o)) {
            return;
        }
    }
    const i = n[yi]?.get(e);
    if (Mu(s)) {
        const o = s instanceof Xs ? s.st() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && Tn(t.$, i);
        const r = n;
        s = st(t.$, r, e, o, t.nt.it);
    } else {
        i && Tn(t.$, i);
    }
    if (fi(s)) {
        const o = n;
        const i = s.then(n => {
            F(t.N, o, e, n, t.j, r);
        });
        t.D.push(i);
        return;
    }
    F(t.N, n, e, s, t.j, r);
};

function ht(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function dt(t, n, e) {
    const s = ht(n, e);
    if (s && t.H?.has(s)) {
        t.H.delete(s);
        return !0;
    }
    return !1;
}

function pt(t, n, e, s, o, r) {
    t.W = function i(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.M;
            if (o) {
                const s = wl(o) ? Yl(o) : null;
                const r = bt(o) || _t(o, t.$.k);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.B = [];
            const r = O(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = wl(i) ? Yl(i) : null;
                const r = bt(i) || _t(i, t.$.k);
                s === null && r == e && o == n ? s = i : r === null ? t.B.push(o, i) : t.U.set(ht(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.B.length; e += 2) {
                if (t.B[e] === n) {
                    s = t.B[e + 1];
                    t.B.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ht(n, e);
            const r = t.U.get(o);
            if (r) {
                s = r;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = wl(t.M) ? Yl(t.M) : null;
                    const e = bt(t.M) || _t(t.M, t.$.k);
                    if (e != null) {
                        const s = ht(n, e);
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = O(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = wl(s) ? Yl(s) : null;
                const e = bt(s) || _t(s, t.$.k);
                if (e != null) {
                    const o = ht(n, e);
                    t.H ||= new Map;
                    t.H.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || Ul(t.N, o, t.W, j(t));
        t.M = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.H?.get(s) || null;
        if (n) {
            t.H.delete(s);
            if (r && t.M) {
                const n = bt(t.M) || _t(t.M, t.$.k);
                if (n != null) {
                    const e = wl(t.M) ? Yl(t.M) : null;
                    const s = ht(e, n);
                    if (s != null) {
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                    }
                }
            }
            n !== t.M && Ul(t.N, o, n, j(t));
            t.M = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function $t(t, n, e) {
    const s = n === "F";
    const o = bt(t.M);
    const r = t.M && _l(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        dt(t, null, o);
        return;
    }
    if (e === null || t.tt) {
        Xl(t.N, t.R, t.W = $l(), J(t));
        t.W.key = e;
        return;
    }
    if (pt(t, null, e, ht(null, e), t.R, !0)) {
        Xl(t.N, t.R, t.W = $l(), J(t));
        t.W.key = e;
    }
}

function yt(t, n) {
    const e = n[Da];
    let s = t.W || t.M;
    const o = t.Y;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ot;
        const l = _t(s, t.$.k);
        const u = o.key || c;
        const f = bt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                dt(t, null, u);
            } else {
                wt(t, s, i, n);
                s = t.W;
                r = !0;
            }
        } else {
            if (pt(t, null, u, u, t.R)) {
                wt(t, s, i, n);
                r = !0;
            }
            s = t.W || t.M;
        }
        if (s) {
            const e = El(s, Fr, t.$.k);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = Et(n[Ui], e[Ui], e[Hi], s, !1);
                        o ||= t;
                        const r = Et(n[Bi], e[Bi], e[Hi], s, !0);
                        o ||= r;
                        e[Qi] = n[Qi];
                    } else if (n) {
                        Sl(t, Fr, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    wt(t, s, i, n);
                    s = t.W;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                Sl(s, or, i);
                s.flags &= -33;
                vn(t.$, s, 4, t.O);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Vs(gt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (S(n)) {
                            const t = n;
                            si(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Us(n) && es(n, fr) || "") + "";
                const i = ii(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            B(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = bt(s);
        const i = e === r;
        const c = _t(s, t.$.k);
        const l = c == null;
        if (s && !l || !s) {
            vt(t);
            s = t.W;
        } else if (i) {
            dt(t, null, e);
        } else {
            pt(t, null, e, e, t.R) && vt(t);
            s = t.W || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!_l(e) || El(e, or, null) === null); ) {
                e = e.parent || Ru(e);
            }
            (function r(t, n, e, s) {
                const o = t.props ||= {};
                o[Vi] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            vn(t.$, s, 8, t.O);
        }
    }
}

function wt(t, n, e, s) {
    n && Pn(t.$, n);
    Xl(t.N, t.R, t.W = $l(), J(t));
    const o = t.Y;
    Sl(t.W, or, e);
    Sl(t.W, Fr, s);
    t.W.key = o.key;
}

function vt(t) {
    Xl(t.N, t.R, t.W = $l(), J(t));
    const n = t.Y;
    Sl(t.W, Fr, n.props);
    n.key && (t.W.key = n.key);
}

function mt(t, n) {
    if (t.M !== null) {
        const e = Su(t.M);
        if (e === 3) {
            if (n !== Gl(t.M)) {
                Zl(t.N, t.M, n);
                return;
            }
            return;
        }
    }
    Fl(t.N, t.R, t.W = pl(document.createTextNode(n), n), j(t));
}

function bt(t) {
    if (t == null || bl(t)) {
        return null;
    }
    return t.key;
}

function _t(t, n) {
    if (t == null || bl(t)) {
        return null;
    }
    const e = El(t, or, n);
    return e ? e.ot : El(t, lr, null);
}

function gt() {}

function Et(t, n, e, s, o = !0) {
    if (St(t) && St(n)) {
        return !1;
    }
    e.$ = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === _r) {
                continue;
            }
            const i = t[s];
            const c = n?.[s];
            if (n && i !== c && At(i, c)) {
                t[s] = c;
                continue;
            }
            if (!n || !At(i, c) && !qt(i, c)) {
                if (s === "class") {
                    if (Mt(i, c)) {
                        continue;
                    }
                } else if (s === "style" && It(i, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = i);
                    const t = ns(e, s);
                    t || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === _r) {
                continue;
            }
            if ((!t || !Jo.call(t, s)) && o) {
                delete n[s];
                const t = ns(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function St(t) {
    if (!t) {
        return !0;
    }
    return Ws(t);
}

function kt(t, n, e, s = null) {
    let o = e;
    const r = s && $n(s) ? $(s) : null;
    if (bl(e)) {
        Tt(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && $n(o) && u(t, r, o);
        const c = o.flags;
        if (c & 3) {
            Pn(t, o);
            Tt(o);
            const r = c & 2 && El(o, or, null) !== null;
            if (r) {
                const e = t.getHostProp(o, Xr);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (Ze(r)) {
                            const n = qu(r);
                            if (n) {
                                Pn(t, r);
                                if (r.h & 1) {
                                    r.h |= 16;
                                    vn(t, o, 128, s);
                                    continue;
                                }
                                Ho(r);
                            } else if (r instanceof vs || r instanceof Xs) {
                                if (r.h & 4) {
                                    continue;
                                }
                                r instanceof vs ? r.$dispose() : Pn(t, r);
                            }
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (S(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Ml(t.rootVNode, e) : e;
                                let c = Kl(o);
                                for (;c; ) {
                                    kt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Pt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = gl(o);
            if (i) {
                if (o === e) {
                    const n = Kl(o);
                    if (n) {
                        gn(n);
                        return;
                    }
                    Rt(t, o);
                }
            } else {
                const t = Kl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Tt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function Rt(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, fr);
    e != null && t.getHostProp(n.slotParent, e) === n && Sl(n.slotParent, e, null);
}

function Pt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Yl(s) === qr) {
            Rt(t, e);
            Hl(n, s, e, !0);
        }
    }
}

function Tt(t) {
    t.flags |= 32;
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Xs && n instanceof Xs && xt(n, t);
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    if (Mu(t) && Mu(n)) {
        const e = t instanceof Xs ? t.st() : t;
        const s = n instanceof Xs ? n.st() : n;
        return sa(() => e.value === s.value);
    }
    return !1;
}

function It(t, n) {
    if (t === n) {
        return !0;
    }
    return Io(t) === Io(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return Ao(t) === Ao(n);
}

function xt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.lt === t.lt && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ut, t.ut);
}

function Nt(t, n) {
    if (!(n instanceof Xs)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Xs && xt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Ko = (t, n, e, s, o) => {
    const r = Fe(t.cn, n, t);
    if (e) {
        r.an = w(e, ":");
        r.$ = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, or));
    if (sr(s)) {
        o = o || t.getHostProp(n, Fr) || Zi;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Wa(s)) {
        const t = s;
        i = () => Le(r, t, [ o || Zi, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => Le(r, t, [ o || Zi ]);
    }
    const l = Ve;
    const u = (e = 0) => ai(() => {
        if (!c) {
            t.setHostProp(n, Dr, null);
            t.setHostProp(n, Br, null);
        }
        e > 0 && yl(n) && Pn(t, n);
        return hi(i(o), t => hi(r.hn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < ci) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Ur);
        if (o) {
            return function r(t, n, e) {
                const s = Lt(n);
                let o = n;
                return hi(s, n => {
                    const s = !n;
                    let r = null;
                    for (const i in e) {
                        if (Object.prototype.hasOwnProperty.call(e, i)) {
                            let c = n;
                            let l = i;
                            if (s) {
                                if (i !== Or && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    r = Xt();
                                    const n = Ve;
                                    n && t.ct(r) || (o = Ft(o, r));
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === Or && (l = "q-d:qinit");
                                Ot(c, l, e[i]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (fi(t) && e < ci) {
            return t.then(() => u(++e));
        }
        if (e >= ci) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Ot(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = Ii(n);
    c && jt(t, f, "capture");
    l && jt(t, f, "preventdefault");
    u && jt(t, f, "stoppropagation");
}

function jt(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Zi && (t.varProps = {});
    t.varProps[s] = !0;
}

function Lt(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Us(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Ke(t)) {
            n.push(...t);
        } else {
            if (fi(t)) {
                return hi(t, t => Lt(t));
            }
            if (Mu(t)) {
                return Lt(t.untrackedValue);
            }
        }
    }
    return null;
}

function Ft(t, n) {
    return Ke(t) ? [ ...t, n ] : [ t, n ];
}

function Xt() {
    return new Vs("script", null, {
        hidden: ""
    }, null, 0, ":useOn");
}

function Dt(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Wt(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = Dt(t[c], c, r, s);
    }
    return i;
}

function Vt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function zt(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = Kl(e);
    const f = X(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Go(c, n, Wt(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        Jl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Go(c, n, Wt(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        Jl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            Hl(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return Go(c, n, Wt(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const m = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const _ = function v(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const E = new Map;
    for (let t = 0; t < _.length; t++) {
        const s = _[t];
        const o = s.key;
        if (b.has(o)) {
            E.set(o, g.length);
            g.push(s);
        } else {
            Hl(n, e, s, !0);
        }
    }
    const S = new Int32Array(m);
    S.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = E.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(m);
    const T = function q(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < T.length; t++) {
        P[R[T[t]]] = 1;
    }
    let I = d;
    let A = w;
    const M = () => {
        for (;I >= h; ) {
            const t = I - h;
            if (P[t] === 1) {
                A = g[S[t]];
                I--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = g[r];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Ul(n, e, t, A);
                A = t;
                I--;
                continue;
            }
            let l = I;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = I - l + 1;
            const d = Go(c, n, Wt(o, a, null, i, l, I), e, A, A, s, null, !0, f);
            return hi(d, () => {
                const t = Vt(e, A, u);
                A = t;
                I = l - 1;
                return M();
            });
        }
    };
    return M();
}

function Ut(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Xr);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Au) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Tu(s, n, t);
                fi(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Bt(t, n) {
    const e = t.props ||= {};
    e[Xi] = n;
}

function Qt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[Di] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[Di] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = jl(n, document, r, e);
    const u = wl(r) && i || r;
    const f = u === r ? null : c;
    Fl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Ht(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[Xi];
    }(t);
    if (!r) {
        return;
    }
    Bt(t, null);
    Mu(r) && (r = r.value);
    return Yo(n, e, r, o, s, null);
}

function Jt(t, n, e, s) {
    const o = t;
    const r = n.getHostProp(o, or);
    if (r && !r.resolved) {
        return r.resolve().catch(n => {
            t.dirty &= -5;
            throw n;
        });
    }
    t.dirty &= -5;
    if (!r) {
        return;
    }
    const i = n.getHostProp(o, Fr) || null;
    return Gt(n, o, o, r, i, e, s);
}

function Yt(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const r = function i(t) {
        const n = t.props;
        const e = n?.[Vi] || null;
        e && delete n[Vi];
        return e;
    }(t);
    if (!r) {
        return;
    }
    return Gt(n, o, r.subscriptionHost || n.rootVNode, r.componentFn, r.props, e, s);
}

function Gt(n, e, s, o, r, i, c) {
    const l = ai(() => Ko(n, e, s, o, r), s => {
        const o = n.getHostProp(e, mr);
        return t(() => Yo(n, i, s, e, c, Ro(o)));
    }, t => {
        n.handleError(t, e);
    });
    if (fi(l)) {
        return l;
    }
    return;
}

function Zt(t, n, e, s, o, r = null) {
    n.push(Vo(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Kt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[Fi] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Mu(e) && (e = e.value);
        const r = s.isConst;
        Zt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[Fi];
    })(t);
}

function tn(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Xr);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Au && n.h & 16) {
            n.h &= -17;
            const t = n;
            Ho(t);
        }
    }
}

function nn(n, e) {
    n.dirty &= -33;
    const s = e.getHostProp(n, Wi);
    if (!s) {
        return;
    }
    const o = s.ft;
    const r = Xe();
    r.$ = e;
    return hi(t(() => je.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return ju(e, s, o);
        }
    });
}

function en(t, n, e, s) {
    t.dirty &= -257;
    if (!__EXPERIMENTAL__.each) {
        return;
    }
    const o = t;
    const r = n.getHostProp(o, Fr) || null;
    if (!r) {
        return;
    }
    let i = rs(r, "items");
    Mu(i) && (i = sa(i));
    const c = rs(r, "key$");
    const l = rs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return zt(n, e, o, s, i, u, f);
    }
    return hi(c.resolve(), t => hi(l.resolve(), r => zt(n, e, o, s, i, t, r)));
}

let tl = null;

const nl = (t, n, e) => {
    tl || (tl = t.insertBefore);
    tl.call(t, n, e);
};

function rn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                nl(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                nl(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let i = 0; i < t.length; i++) {
        const c = t[i];
        if (c instanceof jo) {
            if (n === c.parent && e === c.beforeTarget) {
                s || (s = []);
                s.push(c.target);
                o.add(c.target);
                continue;
            }
            if (!s) {
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (n === c.parent) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            if (o.has(c.target) || e && c.target === e || n && c.target === n) {
                r();
                n = c.parent;
                e = c.beforeTarget;
                s = [ c.target ];
                o.add(c.target);
                continue;
            }
            nl(c.parent, c.target, c.beforeTarget);
            continue;
        }
        if (c instanceof No) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            c.target.remove();
            continue;
        }
        if (c instanceof Co) {
            (o.has(c.target) || e && c.target === e || n && c.target === n) && r();
            const t = c.target;
            t.textContent = "";
            continue;
        }
        if (c instanceof Oo) {
            c.target.nodeValue = c.text;
        } else if (c instanceof Lo) {
            const t = c.target;
            const e = c.attrName;
            const s = c.attrValue;
            const o = s != null ? P(e, s, c.scopedStyleIdPrefix) : null;
            const i = o == null || o === !1;
            if (el(t, e)) {
                t[e] = rl(o);
            } else if (e === Gr) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(Tr, "html");
            } else {
                i ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : g(t, e, o, c.isSvg);
            }
        }
    }
    r();
}

const el = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const rl = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const il = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.zn = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const sl = (t => () => queueMicrotask(t))(ln);

const ll = il(ln);

let ul = !1;

function sn() {
    if (!ul) {
        ul = !0;
        sl();
    }
}

function on() {
    if (!ul) {
        ul = !0;
        ll();
    }
}

function ln() {
    ul = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = s(); ) {
        if (un(e, n)) {
            on();
            return;
        }
    }
}

function un(t, n) {
    const e = Ve;
    const s = $(t);
    const r = s.promise;
    if (r) {
        return;
    }
    const i = s.container;
    if (!t.dirty) {
        cn(i, t, s, e);
        return;
    }
    const c = s.journal ||= [];
    let u = null;
    for (;u = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(u.dirty & 1023)) {
            __EXPERIMENTAL__.pendingBoundary && q(u);
            d(i, s, hn(u, t, i));
            continue;
        }
        if (u.flags & 32) {
            if (u.dirty & 128) {
                tn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            }
            u.dirty &= -1024;
            d(i, s, hn(u, t, i));
            continue;
        }
        let e;
        try {
            if (u.dirty & 1) {
                e = Ut(u, i, s);
            } else if (u.dirty & 2) {
                e = Ht(u, i, c, t);
            } else if (u.dirty & 4) {
                e = Jt(u, i, c, t);
            } else if (u.dirty & 8) {
                e = Yt(u, i, c, t);
            } else if (u.dirty & 256) {
                e = en(u, i, c, t);
            } else if (u.dirty & 16) {
                Kt(u, c);
            } else if (u.dirty & 32) {
                e = nn(u, i);
            } else if (u.dirty & 64) {
                const n = an(i, s, u, t);
                if (n !== null) {
                    u = n;
                    continue;
                }
            } else {
                u.dirty & 512 && Qt(u, c);
            }
        } catch (t) {
            i.handleError(t, u);
        }
        if (e && fi(e)) {
            T(s, u);
            const n = e;
            s.promise = n;
            o(t, i);
            const r = u;
            n.catch(t => {
                s.promise === n && i.handleError(t, r);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                l(t, i);
                sn();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    cn(i, t, s, e);
}

function cn(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        c(n, t);
        s || function o(t, n) {
            const e = $(t);
            const s = e.journal;
            if (s && s.length > 0) {
                rn(s);
                e.journal = null;
            }
            const o = h(e);
            if (o) {
                for (let t = 0; t < o.length; t++) {
                    Rl(n, o[t]);
                }
            }
            (function r(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    Tu(s, t, s.ht);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.pendingBoundary) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function i(t) {
            __EXPERIMENTAL__.pendingBoundary && t.props && Hr in t.props && Sl(t, Hr, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                fn(t);
            });
            return;
        }
        fn(t);
    }
}

function fn(t) {
    t.dt();
}

function an(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        q(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = hn(o[0], s, t);
    d(t, n, i);
    return i;
}

function hn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 1023) {
            if (e && dn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.pendingBoundary && q(s);
    return hn(s, n, e);
}

function dn(t, n) {
    if (!A(n)) {
        return !1;
    }
    $n(n) || pn(t, n, 0);
    return !0;
}

function pn(t, n, e) {
    if ($n(n)) {
        sn();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        Li.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    i(t, r);
    sn();
    return r;
}

function $n(t) {
    return (t.flags & 256) !== 0;
}

function yn(t, n) {
    if (!(n.flags & 1)) {
        let e;
        n.dirty & 16 && function s(t, n) {
            n.dirty &= -17;
            const e = n.getProp(Fi);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Mu(e) && (e = e.value);
                const r = P(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && (e = nn(n, t));
        n.dirty &= -1024;
        return e;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Xr);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Au) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Tu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        fi(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            if (!__EXPERIMENTAL__.each) {
                return;
            }
            const e = n;
            const s = t.getHostProp(e, Fr) || null;
            if (!s) {
                return;
            }
            let o = rs(s, "items");
            Mu(o) && (o = sa(o));
            const r = await rs(s, "key$").resolve();
            const i = await rs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const cl = [];

function wn(t) {
    for (let n = 0; n < cl.length; n++) {
        const e = cl[n];
        const s = cl[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function vn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return Ve;
    }()) {
        const e = yn(t, n);
        fi(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return e;
    }
    const i = e & 1023;
    if ((i ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            cl.push(n);
            let s = A(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const r = $n(o);
                __EXPERIMENTAL__.pendingBoundary && (s ||= A(o) || (t ? I(o) : null));
                if (o === e || t) {
                    M(n, s);
                    wn(o);
                    if (r) {
                        const t = $(o);
                        t.position !== o && (t.position = n);
                    }
                    cl.length = 0;
                    return;
                }
                if (r) {
                    const t = $(o);
                    t.position !== o && (t.position = n);
                }
                cl.push(o);
                o = o.slotParent || o.parent;
            }
            cl.length = 0;
            ((t, ...n) => {
                const e = Ye(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        M(n, A(n) || I(c));
        i && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if ($n(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = $(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        $n(n) ? M(n, A(n)) : function l(t) {
            cl.push(t);
            let n = A(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = $n(e);
                __EXPERIMENTAL__.pendingBoundary && (n ||= A(e) || (s ? I(e) : null));
                if (s) {
                    M(t, n);
                    wn(e);
                    cl.length = 0;
                    return !0;
                }
                cl.push(e);
                e = e.slotParent || e.parent;
            }
            M(t, n);
            cl.length = 0;
            return !1;
        }(n) || pn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const fl = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const al = t => {
    let n = null;
    return e => {
        n || (n = fl(e, t));
        return n.call(e);
    };
};

const hl = (t, n, e = null) => {
    const s = new Ni(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const dl = t => {
    const n = new Ni(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const pl = (t, n) => {
    const e = new Ci(-4084, null, null, null, null, t, n);
    return e;
};

const $l = () => {
    const t = new xi(null, -4094, null, null, null, null, null, null);
    return t;
};

const yl = t => t instanceof Mi;

const wl = t => (t.flags & 1) === 1;

const vl = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const ml = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const bl = t => (t.flags & 4) === 4;

const _l = t => (t.flags & 2) === 2;

const gl = t => {
    const n = t.flags;
    return (n & 2) === 2 && El(t, fr, null) !== null;
};

const Xd = t => t;

const El = (t, n, e) => {
    if (wl(t) || _l(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const Sl = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const kl = (t, n, e, s, o = null) => {
    if (wl(n)) {
        Sl(n, e, s);
        mn(t, Vo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Rl = (t, n) => {
    const e = window;
    e && (e._qwikEv ||= []).push(n);
};

const Pl = t => {
    if (t.key) {
        return;
    }
    const n = iu(t.node, Yr);
    n && (t.key = n);
};

const Tl = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Ti(c)) {
                bn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== Yr && c) {
                if (c.startsWith(Tr)) {
                    const t = i.value;
                    t === "html" ? Sl(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && Sl(e, "value", s.value);
                } else {
                    const t = i.value;
                    Sl(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        El(e, Wr, null) === null && El(e, Vr, null) === null || (n.flags |= 64);
    }
};

const Al = t => {
    if (t._t === "_run") {
        const n = t.getCaptured()?.[0];
        if (sr(n)) {
            return n;
        }
    }
    return t;
};

function bn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Al(Xn(i[t], e));
        c.push(N.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function _n(t, n, e) {
    let s = Kl(n);
    for (;s; ) {
        if (bl(s)) {
            Il(t, s);
            e(s, n);
        } else {
            wl(s) ? e(s, n) : _n(t, s, e);
        }
        s = s.nextSibling;
    }
}

function gn(t) {
    let n = t;
    if (bl(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Kl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const ql = (t, n, e) => {
    let s = t;
    for (;e && s && _l(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !_l(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !_l(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (bl(t) && e && wl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && bu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Il = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Bl(n, !0);
        const o = e.node;
        const r = pu(s);
        let i = ql(n, !1, !0);
        const c = ql(n, !0, !0);
        const l = o || (c && wl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && bl(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                mn(t, Wo(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = ql(i, !1, !0);
        }
        i = n;
        for (;i && bl(i); ) {
            const n = ql(i, !0, !0);
            const e = !n || !bl(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Do(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    mn(t, Wo(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Ml = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let r = -1;
    let i;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        r = parseInt(c);
        i = o.get(r);
    } else {
        i = n;
        const t = i;
        const e = t.vNode;
        if (e) {
            return e;
        }
    }
    if (yl(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = Cl(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = Ol(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = xl(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const xl = (t, n) => {
    let e = Kl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Nl = [];

const Cl = (t, n) => {
    let e = Kl(t);
    for (;e && (!(e instanceof Ni) || e.node !== n); ) {
        if (_l(e)) {
            const t = e.nextSibling;
            const n = Kl(e);
            if (n) {
                t && Nl.push(t);
                e = n;
            } else {
                e = t || (Nl.length ? Nl.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Nl.pop();
        }
    }
    for (;Nl.length; ) {
        Nl.pop();
    }
    return e;
};

const Ol = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const jl = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = hl(o, "errored-host");
    if (vl(e)) {
        Ul(t, r, e, null);
    } else {
        const n = [];
        _n(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Ul(t, r, n[e], null);
        }
    }
    return r;
};

const Ll = rn;

const Fl = (t, n, e, s) => {
    const o = wl(n);
    o && tu(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    Vl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Bl(n, !1);
    l && !c && mn(t, Wo(i, l, Dl(t, n, s)?.node ?? null));
    Wl(n, e, s);
    c && (e.flags |= 32);
};

const Xl = (t, s, o, r) => {
    const i = wl(s);
    i && tu(s);
    const c = o.parent;
    if (o === r) {
        if (c) {
            return;
        }
        r = null;
    }
    Vl(t, c, s, o);
    const l = s.flags & 32;
    const u = !i && s.flags & 2048 ? s.props?.[ur] : null;
    const f = u ? null : i ? s : Ql(s, !1);
    const a = u || f?.node;
    const h = Dl(t, s, r);
    const d = h?.node ?? null;
    const p = gl(o);
    if (p && f && (f.flags & 1536) !== 0) {
        const i = Ql(s, !1);
        const c = Dl(t, s, r)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = e(i, o);
        _n(t, o, s => {
            if (bl(s)) {
                mn(t, Wo(s.node, a, c));
            } else {
                if ((s.flags & 1536) !== u) {
                    const t = function o(t, s, r, i) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let o = null;
                            let a = null;
                            if (wl(c)) {
                                o = c.node;
                                const t = Yl(c);
                                const l = c.parent;
                                const h = u == null ? s : l && Ql(l, !0);
                                if (h) {
                                    const t = e(h, Yl(c));
                                    r = t.elementNamespace;
                                    i = t.elementNamespaceFlag;
                                }
                                const d = Kl(c);
                                a = n(o, t, r, !d);
                                o.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= i;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (eu(o)) {
                                    const t = Me(o);
                                    if (t) {
                                        const n = Kl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(s, i, l, u);
                    t && (s.node = t);
                }
                mn(t, Wo(s.node, a, c));
            }
        });
    } else {
        a && !l && _n(t, o, n => {
            mn(t, Wo(n.node, a, d));
        });
    }
    Wl(s, o, r);
    l && (o.flags |= 32);
};

const Dl = (t, n, e) => {
    let s = null;
    e == null ? _l(n) && (s = ql(n, !0, !1)) : s = _l(e) ? ql(e, !0, !0) : e;
    s && bl(s) && Il(t, s);
    return s;
};

const Wl = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Vl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Hl(t, n, s, !1);
};

const zl = (t, n) => {
    let e = n;
    for (;e && _l(e); ) {
        e = e.lastChild;
    }
    e && bl(e) && (e.flags & 8) === 0 && Il(t, e);
};

const Ul = (t, n, e, s) => {
    vl(e) ? Fl(t, n, e, s) : Xl(t, n, e, s);
};

const Bl = (t, n) => {
    for (;t && !wl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[ur];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Ql = (t, n) => {
    for (;t && !wl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Hl = (t, n, e, s) => {
    bl(e) && Il(t, e);
    if (s) {
        const s = El(n, Gr, null) !== null;
        if (s) {
            return;
        }
        vl(e) ? mn(t, Fo(e.node)) : _n(t, e, n => {
            mn(t, Fo(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const Jl = (t, n, e, s = !0) => {
    const o = Bl(n, !0);
    if (o && s) {
        if (vl(n)) {
            mn(t, Xo(n.node));
        } else {
            const e = Ql(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, Xo(o)) : _n(t, n, n => {
                mn(t, Fo(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Yl = t => {
    const n = Xd(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = du(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = hu(t);
            switch (n) {
              case xr:
                return 512;

              case Nr:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Gl = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Zl = (t, n, e) => {
    Il(t, n);
    n.text = e;
    mn(t, Do(n.node, e));
};

const Kl = t => {
    if (bl(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.pendingBoundary && n === void 0 && wl(t) && function e(t) {
        const n = t.getAttribute(Ld);
        if (n === null) {
            return !1;
        }
        const e = au(t);
        return ku(e) && e.localName === "template" && e.getAttribute(pr) === n && uu(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = tu(t));
    return n;
};

const tu = t => {
    const n = Xd(t);
    let e = n.firstChild;
    if (e === void 0) {
        const t = n.node;
        e = n.parent && eu(t) ? n.firstChild = n.lastChild = null : (t => {
            const n = t.node;
            const e = au(n);
            const s = pu(n)?.qVNodeData?.get(n);
            const o = ((t, n, e, s) => {
                Pl(t);
                __EXPERIMENTAL__.pendingBoundary && n._qSegment;
                if (s) {
                    if (s.charCodeAt(0) === gi && s.charCodeAt(1) === gi) {
                        const n = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(s);
                        const o = n.elementVNodeData;
                        s = n.virtualVNodeData;
                        const r = $u(t, e, o);
                        if (!s) {
                            return r;
                        }
                    }
                    return function o(t, n, e, s) {
                        let o = 0;
                        let r = null;
                        let i = null;
                        let c = null;
                        const l = n => {
                            n.flags = n.flags & 4095 | o << 12;
                            o++;
                            i && (i.nextSibling = n);
                            n.previousSibling = i;
                            n.parent = t;
                            r || (t.firstChild = r = n);
                            i = n;
                        };
                        let u = 0;
                        let f = null;
                        let a = null;
                        const h = t => {
                            const n = ku(t);
                            return !n || n && Rn(t);
                        };
                        let d = null;
                        yu(n, (p, $, y, w, m, b) => {
                            if (_u(p())) {
                                for (;h(s); ) {
                                    s = uu(s);
                                    if (!s) {
                                        throw er(27, [ n, p(), m ]);
                                    }
                                }
                                f = null;
                                c = null;
                                let t = 0;
                                for (;_u(p()); ) {
                                    t *= 10;
                                    t += y() - 48;
                                }
                                for (;t--; ) {
                                    const e = dl(s);
                                    Pl(e);
                                    l(e);
                                    s = uu(s);
                                    for (;ku(s) && Rn(s); ) {
                                        s = uu(s);
                                        if (!s && t > 0) {
                                            throw er(27, [ n, p(), m ]);
                                        }
                                    }
                                }
                            } else if (p() === 59) {
                                Sl(t, mr, $());
                            } else if (p() === 60) {
                                const n = $();
                                if (n.charCodeAt(0) === 95) {
                                    Sl(t, lr, decodeURIComponent(E(n.slice(1))));
                                } else {
                                    (d ||= []).push(t);
                                    Sl(t, or, n);
                                }
                            } else if (p() === 61) {
                                a || (a = Ie(e));
                                const n = $();
                                a.Qn(parseInt(n, 10), t);
                            } else if (p() === 62) {
                                Sl(t, Fr, $());
                            } else if (p() === 64) {
                                t.key = b();
                            } else if (p() === 91) {
                                Sl(t, Xr, $());
                            } else if (p() === 94) {
                                Sl(t, Dr, $());
                            } else if (p() === 96) {
                                a || (a = Ie(e));
                                Sn(t, $(), a);
                            } else if (p() === 63) {
                                a || (a = Ie(e));
                                t.slotParent = Ml(a.rootVNode, $());
                            } else if (p() === 93) {
                                Sl(t, br, $());
                            } else if (p() === 123) {
                                y();
                                l($l());
                                Eu.push(t, r, i, c, o);
                                o = 0;
                                t = i;
                                r = i = null;
                            } else if (p() === gi) {
                                const n = $();
                                const e = decodeURIComponent(E(n));
                                const s = m + n.length + 1;
                                const o = w(s + 1) === gi;
                                let r;
                                if (o) {
                                    y();
                                    r = decodeURI(E($()));
                                    y();
                                } else {
                                    r = E($());
                                }
                                Sl(t, e, r);
                            } else if (p() === 125) {
                                y();
                                t.lastChild = i;
                                o = Eu.pop();
                                c = Eu.pop();
                                i = Eu.pop();
                                r = Eu.pop();
                                t = Eu.pop();
                            } else if (p() === 126) {
                                Sl(t, fr, b());
                            } else {
                                for (;ku(s) && Rn(s); ) {
                                    s = uu(s);
                                }
                                const t = s && su(s) === 3 ? s : null;
                                if (f === null) {
                                    f = t ? t.nodeValue : null;
                                    u = 0;
                                }
                                let n = 0;
                                for (;gu(p()); ) {
                                    n += y() - 97;
                                    n *= 26;
                                }
                                n += y() - 65;
                                const e = f === null ? "" : f.substring(u, u + n);
                                l(c = ((t, n, e) => {
                                    const s = new Ci(-4092, null, t, null, null, n, e);
                                    return s;
                                })(c, t, e));
                                u += n;
                            }
                        });
                        if (d) {
                            a || (a = Ie(e));
                            for (let t = 0; t < d.length; t++) {
                                a.ensureProjectionResolved(d[t]);
                            }
                            d = null;
                        }
                        t.lastChild = i;
                        return r;
                    }(t, s, n, e);
                }
                return $u(t, e, void 0);
            })(t, n, e, s);
            return o;
        })(n);
    }
    return e;
};

let nu = null;

const eu = t => {
    nu || (nu = t.hasAttribute);
    return nu.call(t, Tr);
};

let ru = null;

const iu = (t, n) => {
    ru || (ru = t.getAttribute);
    return ru.call(t, n);
};

const su = al("nodeType");

const ou = t => {
    const n = su(t);
    return n === 3 || n === 1;
};

let lu = null;

const uu = t => {
    lu || (lu = fl(t, "nextSibling"));
    fu || (fu = fl(t, "firstChild"));
    for (;t; ) {
        t = lu.call(t);
        if (t !== null) {
            const n = su(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Rr)) {
                    return En(t, Sr, lu, fu);
                }
                if (t.nodeValue?.startsWith(kr)) {
                    return En(t, [ Sr, Pr ], lu, fu);
                }
                if (n?.startsWith(Tr)) {
                    for (;t && (t = lu.call(t)) && (su(t) !== 8 || !t.nodeValue?.startsWith(Ar)); ) {}
                }
            }
        }
    }
    return t;
};

function En(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = cu(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const cu = al("parentNode");

let fu = null;

const au = t => {
    fu || (fu = fl(t, "firstChild"));
    t = t && fu.call(t);
    if (t && su(t) === 8) {
        lu || (lu = fl(t, "nextSibling"));
        if (t.nodeValue?.startsWith(Rr)) {
            return En(t, Sr, lu, fu);
        }
    }
    for (;t && !ou(t); ) {
        t = uu(t);
    }
    return t;
};

const hu = al("namespaceURI");

const du = al("nodeName");

const pu = al("ownerDocument");

const $u = (t, n, e) => {
    let s = null;
    let o = 0;
    const r = () => {
        for (;ku(i) && Rn(i); ) {
            i = uu(i);
        }
    };
    let i = n;
    r();
    let c = null;
    for (;i; ) {
        const n = su(i);
        let e = null;
        if (n === 3) {
            e = pl(i, i.textContent ?? void 0);
        } else if (n === 1) {
            e = dl(i);
            Pl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        i = uu(i);
        r();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        yu(e, (e, s) => {
            if (e() === 61) {
                n || (n = Ie(t.node));
                const e = s();
                n.Qn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Ie(t.node));
                Sn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function Sn(t, n, e) {
    if (t[yi]) {
        const s = t[yi];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.k(n));
    } else {
        Object.defineProperty(t, yi, {
            get() {
                const s = e.k(n);
                t[yi] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, yi, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const yu = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    const u = () => {
        if (r(e + 1) !== gi) {
            return l();
        }
        c();
        const t = decodeURIComponent(E(l()));
        c();
        return t;
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e, u);
    }
};

const wu = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Tl(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(Yr) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const vu = (t, n) => {
    let e = mu(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = mu(e);
    }
    return !1;
};

const mu = t => t.parent || t.slotParent;

const bu = t => {
    if (t === null || _l(t)) {
        return null;
    }
    return t.node;
};

function kn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (wl(e)) {
                        const t = xe(e.node);
                        if (!t) {
                            return null;
                        }
                        return Me(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (bl(i)) {
            c.push(xn(Gl(i)));
        } else if (_l(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = wu(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== vi && e !== "__scopedStyleIdPrefix__") {
                        const t = El(i, e, null);
                        s.push(" " + e + "=" + xn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (mi[El(i, vi, null) || "V"] || mi.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Kl(i);
            u && c.push("  " + kn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (wl(i)) {
            const s = Yl(i);
            const l = [];
            $n(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? wu(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = El(i, n, null);
                l.push(" " + n + "=" + xn(e));
            }
            const f = bu(i);
            if (f) {
                const t = pu(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + xn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + xn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (ml(i) || e) {
                const e = Kl(i);
                e && c.push("  " + kn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const _u = t => 48 <= t && t <= 57;

const gu = t => 97 <= t && t <= 122;

function Rn(t) {
    return !t.hasAttribute(Yr) || t.nodeName === "STYLE" && (t.hasAttribute(mr) || t.hasAttribute(yr));
}

const Eu = [];

const Su = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw er(26, [ n ]);
};

const ku = t => t && typeof t == "object" && su(t) === 1;

const Ru = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!_l(t) || El(t, or, null) === null); ) {
            const e = t.slotParent;
            const s = _l(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function Pn(t, n) {
    yl(n) && wl(n) && tu(n);
    const e = n[yi];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Tn(t, n);
    }
    e.clear();
}

function Tn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof ys) {
            An(t, s, n);
            s instanceof vs && qn(s, n);
        } else if (os(s)) {
            const t = s[Hi];
            In(t, n);
        } else if (t.$t.has(s)) {
            const e = t.$t.get(s);
            const o = Vu(e);
            In(o, n);
        }
    }
    e.clear();
}

function An(t, n, e) {
    const s = n.ft;
    s && s.has(e) && s.delete(e);
    if (n instanceof Xs && !s?.size) {
        n._ = void 0;
        Pn(t, n);
    }
}

function qn(t, n) {
    const e = t.yt;
    e && e.has(n) && e.delete(n);
    const s = t.wt;
    s && s.has(n) && s.delete(n);
    t.vt();
}

function In(t, n) {
    const e = t?.ft;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Pu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = zo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Au(6 | i, r, o._, t, null);
    s(c);
    const l = o.$;
    const {hn: u} = o;
    const f = hi(u, () => Tu(c, l, o._));
    fi(f) && (o.hn = f);
};

const Tu = (t, n, e) => {
    const s = t.Hn;
    if (s) {
        return s;
    }
    const o = t => {
        Df(t, "hook");
        n.handleError(t, e, "hook");
    };
    let r = null;
    const i = hi(((t, n) => {
        const e = t.Jn;
        if (e) {
            return e;
        }
        const s = t.zn;
        if (!s) {
            return;
        }
        t.zn = null;
        try {
            const e = s();
            if (fi(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Jn === s && (t.Jn = void 0);
                });
                t.Jn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        t.h = t.h & -5 | 64;
        const s = Xe(n.cn, e, "qTask");
        s.$ = n;
        const i = t.bt.getFn(s, () => Pn(n, t));
        const c = hs(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.zn = () => {
                            t.zn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    fi(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return ai(() => i(u), l, s => {
            if (fi(s)) {
                return s.then(() => {
                    t.Hn === r && (t.Hn = null);
                    return Tu(t, n, e);
                }, o);
            }
            o(s);
        });
    });
    if (fi(i)) {
        r = i.finally(() => {
            if (t.Hn === r) {
                t.Hn = null;
                t.h & 4 && vn(n, e, 1);
            }
        });
        t.Hn = r;
        return r;
    }
    return i;
};

class Au extends wi {
    h;
    Ft;
    ht;
    bt;
    zn;
    Jn;
    Hn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Ft = n;
        this.ht = e;
        this.bt = s;
        this.zn = o;
    }
}

const qu = t => t instanceof Au;

function Mn(t, n) {
    const e = Ie(n);
    return Gf(e, () => {
        typeof this === "string" && Ea(Sa(e, this));
        const t = ga[0];
        if (!t.ht) {
            return;
        }
        if (t.h & 68) {
            return;
        }
        t.h |= 4;
        vn(e, t.ht, 1);
    });
}

const Iu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Mu = t => t instanceof ys;

const xu = (t, n) => {
    t.add(n);
};

const Nu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Cu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        qu(e) ? o = e.bt : e instanceof vs ? o = e.Dt : s === ":" && (o = n.getHostProp(e, or));
        o && n.serializationCtx.Lt.add(o);
    }
};

const Ou = (t, n) => {
    if (t && (!n || t === n || Fd(t))) {
        return t;
    }
    return n;
};

const ju = (t, n, e) => {
    const s = ze;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (qu(o)) {
                o.h |= 4;
                vn(t, o.ht, 1);
            } else if (o instanceof vs) {
                o.An();
            } else if (o instanceof ys) {
                o.invalidate();
            } else if (r === ":") {
                vn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Bt(o, n);
                    vn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Ds) {
                    const e = i.data;
                    const c = {
                        isConst: e.rt,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[Fi];
                            if (!o) {
                                o = new Map;
                                s[Fi] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(Fi);
                        if (!n) {
                            n = new Map;
                            t.setProp(Fi, n);
                        }
                        n.set(r, c);
                    }
                    vn(t, o, 16);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Lu = t => Ze(t) && typeof t[Sf] === "function";

const Fu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Xu = t => {
    t.h |= 4;
};

const Du = [];

function xn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (qu(t)) {
            return `Task(${xn(t.bt)})`;
        }
        if (sr(t)) {
            return `Qrl(${t._t})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Du.includes(t)) {
                return "*";
            }
            Du.length;
            try {
                Du.push(t);
                if (Array.isArray(t)) {
                    return yl(t) ? "(" + (El(t, vi, null) || "vnode") + ")" : t.map(xn);
                }
                if (Mu(t)) {
                    return t instanceof Xs ? "WrappedSignal" : t instanceof vs ? "ComputedSignal" : "Signal";
                }
                if (Hu(t)) {
                    return "Store";
                }
                if (Us(t)) {
                    return Wu(t);
                }
                if (yl(t)) {
                    return "(" + (El(t, vi, null) || "vnode") + ")";
                }
            } finally {
                Du.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Wu = t => {
    if (Us(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Da];
            if (n) {
                const [t] = n;
                return "Component(" + t._t + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + xn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Wu(e);
                    }
                } else {
                    n += Wu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Vu = t => t[fs];

const zu = t => {
    try {
        return t?.[cs] || null;
    } catch {
        return null;
    }
};

const Uu = (t, n) => {
    const e = Vu(t);
    e && e.force(n);
};

const Bu = (t, n) => {
    const e = Vu(t);
    if (e) {
        return (e.ft?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Qu = t => zu(t) || t;

const Hu = t => cs in t;

function Nn(t, n, e) {
    return new Proxy(n, new Yu(e, t || null));
}

const Ju = (t, n, e) => {
    if (Ge(t) && e) {
        let s = e.$t.get(t);
        if (!s) {
            s = Nn(e, t, n);
            e.$t.set(t, s);
        }
        return s;
    }
    return t;
};

class Yu {
    h;
    $;
    ft=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = zu(this);
        ju(this.$, this, jn(n, t, this.ft));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === cs) {
                return t;
            }
            if (n === fs) {
                return this;
            }
            return t[n];
        }
        const e = na();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.an;
            o && Cn(t, Array.isArray(t) ? as : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        let r = !1;
        if (o & 1 && Ze(s)) {
            try {
                r = !Object.isFrozen(s) && !Hu(s) && !Object.isFrozen(t);
            } catch {}
        }
        if (r) {
            return Ju(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Qu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && On(n, s, t, this);
        } else {
            On(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || ju(this.$, this, jn(t, n, this.ft));
        return !0;
    }
    has(t, n) {
        if (n === cs) {
            return !0;
        }
        if (typeof n === "string") {
            const e = na();
            if (e) {
                const s = e.an;
                s && Cn(t, Array.isArray(t) ? as : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = na();
        const e = n?.an;
        e && Cn(t, as, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Cn(t, n, e, s, o) {
    const r = e.ft ||= new Map;
    let i = r.get(n);
    if (!i) {
        i = new Set;
        r.set(n, i);
    }
    const c = Ve;
    const l = __EXPERIMENTAL__.pendingBoundary && e instanceof Yu && c;
    xu(i, s);
    Nu(s, t);
    if (c) {
        const i = Ou(o, e.$);
        l && i?.wn?.(t, s, n, r);
        Cu(s, i);
    }
}

function On(t, n, e, s) {
    e[t] = n;
    const o = jn(e, t, s.ft);
    o && ju(s.$, s, o);
}

function jn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(as);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Gu = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const Zu = '"';

const Ku = "[";

const tc = "]";

const nc = ",";

const ec = Symbol();

const rc = [ void 0, null, !0, !1, "", Gi, Zi, ls, as, Yi, ho, fo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const ic = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const sc = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function Ln(t, n, e) {
    let s = n._t;
    let o = n.gt;
    const r = ri();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => sr(t) && t._t == ir)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.Et(null, 0, e) + "";
    } else {
        o || (o = t.St(n.ot));
        if (!o) {
            throw er(14, [ n._t ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.kt(c[s]);
            const r = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + r;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Fn(t, n, e, s) {
    return Ta(t, n, null, null, e, s);
}

function Xn(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const r = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const i = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return Fn(o, r, i, n);
}

class oc {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class lc {
    Yn;
    Gn=0;
    Pt=[];
    Zn=0;
    Kn=new Set;
    te=new Map;
    ne;
    ee=new Map;
    re=0;
    ie=new WeakSet;
    Jt;
    se=typeof Temporal !== "undefined";
    constructor(t) {
        this.Yn = t;
        this.Jt = t.Jt;
    }
    async serialize() {
        const t = this.re;
        this.re = 0;
        this.ie = new WeakSet;
        try {
            await this.outputRoots();
        } finally {
            this.re = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.re;
        this.re = s;
        this.ie = new WeakSet;
        this.Jt.write(Ku);
        this.Yn.oe = 0;
        try {
            this.Jt.write(t + "");
            this.Jt.write(nc);
            this.Jt.write(Ku);
            await this.outputSelectedRoots(n);
            this.Jt.write(tc);
            const s = this.getForwardRefsPayload();
            this.Yn.oe = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Jt.write(nc);
                s ? this.outputForwardRefsArray(s) : this.Jt.write("0");
            }
            if (e !== void 0) {
                this.Jt.write(nc);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Jt.write(Zu);
                    this.writeRootRefPath(e);
                    this.Jt.write(Zu);
                }
            }
        } finally {
            this.re = o;
        }
        this.Jt.write(tc);
    }
    le(t) {
        this.Jt = t;
    }
    outputArray(t, n, e) {
        this.Jt.write(Ku);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Jt.write(nc) : s = !0;
            e(t[n], n);
        }
        this.Jt.write(tc);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : Zu + t + Zu;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Jt.write(n.slice(s, e));
            this.Jt.write("<\\/");
            s = e + 2;
        }
        this.Jt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Jt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Jt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Jt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Jt.write(Zu);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Jt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Jt.write(Zu);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Jt.write(t + nc);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Jt.write(Zu);
                this.writeRootRefPath(n);
                this.Jt.write(Zu);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Jt.write(t + nc);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Jt.write(t + nc + n);
        } else if (typeof n === "string") {
            this.Jt.write(t + nc);
            this.outputString(n);
        } else {
            this.Jt.write(t + nc);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Yn.getSeenRef(t);
        const o = !e && this.te.get(t);
        if (s) {
            s.ne && this.isSeenInStreamedRoot(s) && (s = this.Yn.ue(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Yn.ce(t, this.ne, n);
            }
            s = this.Yn.kt(t, !0);
        }
        if (s.ne) {
            if (this.ne) {
                this.Yn.fe(s, t);
            } else {
                this.Yn.fe(s, t, n);
                t = this.Yn.ae[n];
            }
        }
        if (typeof o === "number") {
            this.Pt[o] = s.Ft;
            this.te.delete(t);
        }
        const r = t instanceof wc ? t.he : s.Ft;
        if (!this.ne && r === n) {
            return s;
        }
        this.output(1, r);
    }
    isSeenInStreamedRoot(t) {
        for (;t.ne; ) {
            t = t.ne;
        }
        return t.Ft < this.re;
    }
    writeValue(t, n) {
        if (_f(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === ls) {
                    this.output(3, 7);
                } else if (t === as) {
                    this.output(3, 8);
                } else if (t === Yi) {
                    this.output(3, 9);
                } else {
                    if (t !== ec) {
                        throw er(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === ho) {
                    this.output(3, 10);
                } else if (t === fo) {
                    this.output(3, 11);
                } else if (sr(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = Ln(this.Yn, t, !0);
                        let o;
                        if (n !== "") {
                            const r = this.Yn.kt(n);
                            const i = this.Yn.kt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(i, s) : null;
                            o = [ r, "#", {
                                id: i,
                                base: r
                            } ];
                            if (s) {
                                let t = 0;
                                let n = i;
                                let e = 0;
                                o.push("#");
                                for (let r = 0; r <= s.length; r++) {
                                    if (r === s.length || s[r] === " ") {
                                        if (r > e) {
                                            const i = t + +s.slice(e, r);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: i,
                                                base: n
                                            });
                                            t = i;
                                            n = i;
                                        }
                                        e = r + 1;
                                    }
                                }
                            }
                            const l = `${r}#${i - r}${c ? "#" + c : ""}`;
                            const u = this.ee.get(l);
                            if (u) {
                                const t = this.Yn.kt(u);
                                this.output(1, t);
                                return;
                            }
                            this.ee.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Wa(t)) {
                        throw er(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[Da];
                        this.Yn.de.add(n._t);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Gi) {
                    this.output(3, 5);
                } else if (t === Zi) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof wc) {
                    this.output(1, t.he);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.ne;
                        this.ne = e;
                        this.writeObjectValue(t);
                        this.ne = n;
                    }
                }
                break;

              default:
                throw er(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (os(t)) {
            const n = t[Qi];
            this.output(38, [ $c(n), n.varProps, n.constProps, t[Hi].ft ]);
        } else if (t instanceof Ds) {
            const {j: n, rt: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof us) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof oc) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (Hu(t)) {
            const n = Vu(t);
            const e = zu(t);
            const s = n.h;
            const o = n.ft;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Yn.$t.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Lu(t)) {
            const n = t[Sf](t);
            if (fi(n)) {
                const t = this.resolvePromise(n, (t, n) => new uc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.ne.Ft;
                this.ne = this.ne.ne;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        _f(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Yn.pe(t)) {
            this.Yn.$e(t.ye, 16);
            this.output(11, t.ye.id);
        } else if (t instanceof ys) {
            if (t instanceof ks) {
                const n = function e(t, n) {
                    if (n === ls) {
                        return n;
                    }
                    return hi(t.Dt.resolved || t.Dt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && Sf in n && (e = n[Sf](n));
                        e === void 0 && (e = ls);
                        return e;
                    });
                }(t, t.Xt);
                if (fi(n)) {
                    const e = this.resolvePromise(n, (n, e) => new uc(34, n, e, t.ft, t.Dt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Dt, t.ft, n ]);
                }
                return;
            }
            if (t instanceof Xs) {
                this.output(31, [ ...Dn(this.Yn, t), t.h, t._, ...t.ft || [] ]);
            } else if (t instanceof vs) {
                let n = t.Xt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = _f(t.Xt);
                const i = !!(t.h & 512);
                const c = i && !!t.Wt;
                const l = i && t.zt !== 1 ? t.zt : void 0;
                const u = i && t.Bt !== 0 ? t.Bt : void 0;
                const f = i && t.h & -25 || void 0;
                o || r || c ? n = ls : e ? n = t.Xt : s && (n = ls);
                const a = [ t.Dt, t.ft ];
                if (i) {
                    const n = t.Wt;
                    a.push(t.yt, t.wt, n === void 0 ? n : Nf(n));
                    a.push(f || void 0);
                }
                n === ls && l === void 0 && u === void 0 || a.push(n === void 0 ? ec : n);
                if (i) {
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Xt;
                const e = [ n === void 0 ? ec : n ];
                t.ft && e.push(...t.ft);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            for (const e of Object.entries(t)) {
                n.push(e[0], e[1]);
            }
            this.output(23, n);
        } else if (this.Yn.we(t)) {
            if (t.vnodeData && t.vnodeData[0] & 32 && /[A-Za-z]/.test(t.id)) {
                this.output(3, 0);
                return;
            }
            const n = this.Yn.kt(t);
            this.Yn.ve(t, jr, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                if (!this.ie.has(e)) {
                    this.ie.add(e);
                    cc(e, this.Yn);
                }
                this.Yn.$e(t, 16, !0);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Yn.$e(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Us(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Au) {
            const n = [ t.bt, t.h, t.Ft, t.ht ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (fi(t)) {
            const n = this.resolvePromise(t, (t, n) => new uc(24, t, n));
            this.output(2, n);
        } else if (t instanceof uc) {
            if (t.me === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ft, t.be ]);
                } else {
                    if (!t._e) {
                        console.error(t.be);
                        throw er(33);
                    }
                    {
                        const n = this.ne.Ft;
                        this.ne = this.ne.ne;
                        this.writeValue(t.be, n);
                    }
                }
            } else {
                this.output(24, [ t._e, t.be ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof pc) {
            const n = t.ge;
            if (this.getSeenRefOrOutput(n, this.ne.Ft, !0)) {
                let t = this.te.get(n);
                if (t === void 0) {
                    t = this.Zn++;
                    this.te.set(n, t);
                    this.Pt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.se && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.se && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.se && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.se && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!yl(t)) {
                throw er(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Zn++;
        t.then(s => {
            this.Kn.delete(t);
            this.Pt[e] = this.Yn.kt(n(!0, s));
        }).catch(s => {
            this.Kn.delete(t);
            this.Pt[e] = this.Yn.kt(n(!1, s));
        });
        this.Kn.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Yn.Ee + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {ae: n} = this.Yn;
        for (;this.Gn < n.length || this.Kn.size; ) {
            let e = t > 0;
            for (;this.Gn < n.length; this.Gn++) {
                e ? this.Jt.write(nc) : e = !0;
                this.writeValue(n[this.Gn], this.Gn);
                t++;
            }
            if (this.Kn.size) {
                try {
                    await Promise.race(this.Kn);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.Kn.size; ) {
            if (e < t.length) {
                n ? this.Jt.write(nc) : n = !0;
                const s = t[e++];
                this.writeValue(this.Yn.ae[s], s);
                continue;
            }
            try {
                await Promise.race(this.Kn);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Pt.length - 1;
        for (;t >= 0 && this.Pt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Pt.length - 1 ? this.Pt : this.Pt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Jt.write(Zu);
                this.writeRootRefPath(t);
                this.Jt.write(Zu);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Jt.write(Ku);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Yn.Se = this.Yn.ae.length;
        this.Yn.ke = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Jt.write(nc);
            this.Jt.write(14 + nc);
            this.outputForwardRefsArray(n);
        }
        this.Jt.write(tc);
        this.Yn.Re = this.Yn.ae.length + (this.Yn.ke ? 1 : 0);
        this.Yn.oe = e;
    }
}

class uc {
    me;
    _e;
    be;
    ft;
    bt;
    constructor(t, n, e, s, o) {
        this.me = t;
        this._e = n;
        this.be = e;
        this.ft = s;
        this.bt = o;
    }
}

const cc = (t, n) => {
    const e = t.length;
    for (let s = 1; s < e; s++) {
        const e = t[s];
        if (fc(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === jr || t === Fr && (Ws(s) || ac(e, s))) {
                    continue;
                }
                n.kt(s);
            }
        }
    }
};

const fc = t => typeof t === "object" && t !== null && !Ws(t);

const ac = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, or)) {
        return !1;
    }
    const s = n[Qi];
    return Ws(s.varProps) && !hc(n) && !dc(t[_r]);
};

const hc = t => !!t[Hi].ft?.size;

const dc = t => t instanceof Map && t.has(":");

function Dn(t, n) {
    n.Rt && n.Rt[0] === "{" && (n.Rt = `(${n.Rt})`);
    const e = t.Et(n.Rt, n.ut.length, n.lt);
    return [ e, n.ut ];
}

class pc {
    ge;
    constructor(t) {
        this.ge = t;
    }
}

const $c = t => new pc(t);

let yc = () => !1;

class wc {
    he;
    constructor(t) {
        this.he = t;
    }
}

class vc {
    NodeConstructor;
    DomRefConstructor;
    St;
    ve;
    $t;
    Jt;
    Pe=new Map;
    Te=new Map;
    Ae=0;
    qe=[];
    ae=[];
    Ie=[];
    Me;
    Ee=0;
    Re=0;
    oe=0;
    Se=0;
    ke=!1;
    xe=new Set;
    Lt=new Set;
    jt=new Set;
    de=new Set;
    Ne;
    $e=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this.ve = s;
        this.$t = o;
        this.Jt = r;
        this.Ne = new lc(this);
    }
    async Ht() {
        await this.Ne.serialize();
    }
    async Ce(t, n, e, s) {
        await this.Ne.serializePatch(t, n, e, s);
    }
    le(t) {
        this.Jt = t;
        this.Ne.le(t);
    }
    getSeenRef(t) {
        return this.Pe.get(t);
    }
    ce(t, n, e) {
        const s = {
            Ft: e,
            ne: n
        };
        this.Pe.set(t, s);
        return s;
    }
    Oe(t) {
        const n = [];
        for (;t.ne; ) {
            n.unshift(t.Ft);
            t = t.ne;
        }
        n.unshift(t.Ft);
        return n;
    }
    fe(t, n, e) {
        const s = this.Oe(t);
        const o = e === void 0;
        e === void 0 && (e = this.ae.length);
        this.ae[e] = new wc(s);
        o && (this.Ie[e] = n);
        t.ne = null;
        t.Ft = e;
        o && this.Me?.(e, this.ae[e], n);
    }
    kt(t, n = !1) {
        let e = this.Pe.get(t);
        let s;
        if (e) {
            e.ne && this.fe(e, t);
            s = e.Ft;
        } else {
            s = this.ae.length;
            e = {
                Ft: s
            };
            this.Pe.set(t, e);
            this.ae.push(t);
            this.Ie.push(t);
            this.Me?.(s, t, t);
        }
        return n ? e : s;
    }
    ue(t) {
        const n = this.ae.length;
        const e = {
            Ft: n
        };
        this.Pe.set(t, e);
        this.ae.push(t);
        this.Ie.push(t);
        this.Me?.(n, t, t);
        return e;
    }
    je(t, n) {
        const e = this.ae.length;
        const s = {
            Ft: e
        };
        this.Pe.set(n, s);
        this.ae.push(t);
        this.Ie.push(n);
        return e;
    }
    we(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    pe(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Le(t) {
        const n = this.Pe.get(t);
        return n && (n.ne ? void 0 : n.Ft);
    }
    Et(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.Te.get(t);
        if (o === void 0) {
            o = this.Ae + this.qe.length;
            this.Te.set(t, o);
            if (s) {
                this.qe.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.qe.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Fe(t, n) {
        this.Ae = t;
        if (n) {
            this.Te.clear();
            for (let t = 0; t < n.length; t++) {
                this.Te.set(n[t], t);
            }
        }
    }
}

const Dd = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = Object.assign(Gu(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    yc = n ? t => t instanceof n : () => !1;
    return new vc(t, n, e, s, o, r);
};

const mc = (t, n) => t[n];

const bc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        Hu(t) && (t = zu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!bc(sa(mc, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!bc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (qu(t)) {
            return !0;
        }
        if (os(t)) {
            return !0;
        }
        if (fi(t)) {
            return !0;
        }
        if (Us(t)) {
            return !0;
        }
        if (Lu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ds) {
            return !0;
        }
        if (yc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (sr(t) || Wa(t) || t === ho || t === fo) {
            return !0;
        }
    } else if (t === Yi || t === ls || t === as) {
        return !0;
    }
    return !1;
};

const _c = (t, n) => {
    let e = yl(t) ? kn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Ze(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let gc = !1;

const Ec = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (gc = !0);
            const n = `{${Ze(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${_c(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = kc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${Ec(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Sc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = gc ? "" : `(${JSON.stringify(t).length} chars)`;
        gc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Sc = t => sc[t] || `Unknown(${t})`;

const kc = t => ic[t] || `Unknown(${t})`;

function Wn(t, n, e, s = 0) {
    const o = Vn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Vn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const r = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let r = 1;
        let i = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            i = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = i + 1;
            const u = o;
            r = u[i];
            o = u[c];
            if (r === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                r = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[i] = 1;
            l[c] = n / 2;
        }
        t[n] = r;
        t[n + 1] = o;
    };
    for (let i = e; i < t.length; i += 2) {
        s(t[i], t[i + 1]) ? r(i) : o(t[i]) && (n.Pt = t[i + 1]);
        yield;
    }
}

const Rc = new WeakMap;

const Pc = /^[A-Za-z0-9+/]*$/;

const Tc = t => {
    const n = t.Qt === void 0;
    t.Qt ??= new Map;
    return n;
};

const Ac = (t, n) => {
    if (n) {
        t.Qt.clear();
        t.Qt = void 0;
    }
};

const qc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.k(e);

      case 2:
        const s = t.Gt(e);
        return s === -1 || s === void 0 ? Yi : t.k(s);

      case 14:
        return e;

      case 3:
        return rc[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const r = s.indexOf("#", o + 1);
                const i = +s.slice(0, o);
                const c = r === -1 ? +s.slice(o + 1) : +s.slice(o + 1, r);
                const l = i + c;
                const u = t.k(i);
                const f = t.k(l);
                n = Fn(u, f, r !== -1 ? s : null, t);
            } else {
                n = Fn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Au(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return Xa(null);

      case 30:
        return new ys(t, 0);

      case 31:
        return new Xs(t, null, null, null);

      case 32:
        return new vs(t, null);

      case 33:
        return new Rs(t, null, void 0, {});

      case 34:
        return new ks(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = qc(t, s, o);
            const i = Ju(r, 0, t);
            cf(s) && t.Qt.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Vs(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        Rc.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !Pc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw er(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return y(null);

      case 10:
        return zn(t, e);

      case 11:
        const l = zn(t, e);
        if (yl(l)) {
            tu(l);
            return bu(l);
        }
        throw er(17, [ typeof l ]);

      case 39:
        return new Ds({});

      case 42:
        return new Ds({
            j: null,
            rt: !0
        });

      case 43:
        return new Ds({
            j: null,
            rt: !1
        });

      case 40:
      case 44:
        return new us(null, null, null, null);

      case 41:
        return new oc;

      default:
        throw er(18, [ n ]);
    }
};

function zn(t, n) {
    return n ? t.rootVNode ? Ml(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Ic = (t, n, e) => {
    let s = null;
    let o = null;
    if (nr(t)) {
        o = t;
    } else {
        if (!tr(t)) {
            throw er(7, [ t ]);
        }
        s = t;
    }
    return Ta(s, n, null, o, e);
};

const Mc = (t, n, e) => Ta(null, n, t, null, e);

const xc = (t, n) => Ta(null, t, null, null, n);

const Nc = (t, n, e) => {
    const s = xc(t, e);
    return s;
};

const Cc = (t, n, e, s) => Ta(t, e, null, n, s);

const Oc = (t, n, e, s, o) => {
    const r = Cc(t, n, e, o);
    r.Xe(s);
    return r;
};

const jc = (t, n, e, s) => {
    const o = Ic(t, n, s);
    return o;
};

const Lc = (t, n, e, s) => {
    const o = Mc(t, n, s);
    return o;
};

const Fc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

function Un(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Xc = (t, n, e) => new Xs(null, t, n, e || null);

class Dc {
    De;
    $t;
    pn=null;
    It=!1;
    cn;
    k;
    dn;
    We=0;
    Zt=null;
    Ve=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.dn = t;
        this.cn = n;
        this.De = rr;
        this.$t = new WeakMap;
        this.k = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return ua(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        if (Ve) {
            return Dd(t, n, e, this.setHostProp.bind(this), this.$t, s);
        }
        throw Error("Serialization context is only available on the server");
    }
    dt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Wc = Symbol();

const Wd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Wc] = t;
    return n;
};

class Vc {}

class zc {}

const Uc = t => {
    const n = t.Tt;
    return !!n && (n.vnodeData[0] & 32) !== 0;
};

const Bc = t => {
    t.catch(() => {});
};

function Bn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function Qn(n, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    const i = t => {
        Bc(t);
        o.push(t);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            let e = "render";
            try {
                const c = o.pop();
                if (c === Vc) {
                    const s = o.pop();
                    if (__EXPERIMENTAL__.catchBoundary && Uc(n)) {
                        continue;
                    }
                    e = "hook";
                    await t(() => o.push(s()));
                    continue;
                }
                if (__EXPERIMENTAL__.catchBoundary && c === zc) {
                    const t = o.pop();
                    if (Uc(n)) {
                        continue;
                    }
                    const e = t.apply(n);
                    fi(e) && await e;
                    continue;
                }
                if (typeof c === "function") {
                    if (c === Promise) {
                        const t = o.pop();
                        if (__EXPERIMENTAL__.catchBoundary && Uc(n)) {
                            continue;
                        }
                        o.push(await t);
                    } else {
                        const t = c.apply(n);
                        fi(t) && await t;
                    }
                    continue;
                }
                if (__EXPERIMENTAL__.catchBoundary && Uc(n)) {
                    fi(c) && c.catch(() => {});
                    continue;
                }
                Jn(n, r, i, c, s);
            } catch (t) {
                n.handleError(t, n.getOrCreateLastNode(), e);
            } finally {
                const t = n.streamHandler.waitForPendingFlush();
                fi(t) && await t;
            }
        }
    })();
}

function Hn(t, n) {
    t(n);
    __EXPERIMENTAL__.catchBoundary && typeof n === "function" && t(zc);
}

function Jn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                Hn(n, s[t]);
            }
        } else if (Mu(s)) {
            t.openFragment(Zi);
            const e = t.getOrCreateLastNode();
            const o = s instanceof Xs ? s.st() : s;
            n(t.closeFragment);
            n(() => ua(o, e, ".", t));
            n(Vc);
        } else if (fi(s)) {
            t.openFragment(Zi);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function r(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                if (__EXPERIMENTAL__.catchBoundary && Uc(t)) {
                    return;
                }
                const n = () => ({
                    currentStyleScoped: o.currentStyleScoped,
                    parentComponentFrame: o.parentComponentFrame
                });
                try {
                    for await (const e of s) {
                        await Qn(t, e, n());
                        await t.streamHandler.flush();
                    }
                } catch (e) {
                    t.handleError(e, t.getOrCreateLastNode(), "render");
                    await Qn(t, null, n());
                }
            });
        } else {
            const r = s;
            const i = r.type;
            if (typeof i === "string") {
                (function e(t, n) {
                    const e = es(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(r, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(i, r.key, r.varProps, r.constProps, o.currentStyleScoped, s, !!(r.flags & 4));
                c && t.htmlNode(c);
                __EXPERIMENTAL__.catchBoundary && es(r, $r) && n(((t, n) => {
                    const e = t.Tt;
                    t.Tt = n;
                    return () => {
                        t.Tt = e;
                    };
                })(t, t.getOrCreateLastNode()));
                n(t.closeElement);
                if (i === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (i === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.At) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = r.children;
                l != null && Hn(n, l);
            } else if (nr(i)) {
                if ((__EXPERIMENTAL__.pendingBoundary || __EXPERIMENTAL__.catchBoundary) && (t => typeof t === "function" && Wc in t)(i)) {
                    n(() => (t => t[Wc])(i)(t, r, o, n));
                    return;
                }
                if (i === fo) {
                    const e = r.key != null ? {
                        [Lr]: r.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = r.children;
                    s != null && Hn(n, s);
                } else if (i === ho) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const i = {};
                        i[ar] = s;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = R(c, r, t);
                        i[fr] = u;
                        n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = r.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        Hn(n, a);
                        n(Bn(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Zi;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (i === yo) {
                    t.commentNode(es(r, "data") || "");
                } else if (i === vo) {
                    t.streamHandler.flush();
                    const s = r.children;
                    let i;
                    i = nr(s) ? s({
                        async write(n) {
                            await Qn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    fi(i) ? e(i) : n(i);
                } else if (i === $o) {
                    t.htmlNode(es(r, "data"));
                } else if (i === wo) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    Hn(n, r.children);
                } else if (Wa(i)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    n(Bn(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(r.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Da];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(or, o);
                        s.setProp(Fr, r);
                        n.key !== null && s.setProp(Lr, n.key);
                        return Ko(t, s, s, o, r);
                    })(t, r, i);
                    if (fi(l)) {
                        Bc(l);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const r = Ro(s.getProp(mr));
                            n(e);
                            n(Bn(o, r, c));
                        });
                    } else {
                        n(l);
                        const t = Ro(s.getProp(mr));
                        n(Bn(o, t, c));
                    }
                } else {
                    const s = {
                        [Lr]: r.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Ko(t, o, n, e, s.props);
                    })(t, o && o.componentNode, i, r);
                    fi(c) ? e(c) : n(c);
                }
            }
        }
    }
}

function Yn(t, n, e, s) {
    if (!__EXPERIMENTAL__.catchBoundary) {
        throw n;
    }
    for (let o = e; o; o = o.parentComponent) {
        const e = Zn(o);
        if (!e || !e.qt) {
            continue;
        }
        if (t.It && e.Mt) {
            throw n;
        }
        Wf(e, n, s);
        $i(t).xt = !0;
        t.It && Ff(e);
        Gn(t, o, e);
        return;
    }
    throw n;
}

function Gn(t, n, e) {
    const s = new Map;
    let o = null;
    let r = 0;
    for (let t = n; t; t = t.parentComponent) {
        t.id && s.set(t.id, {
            node: t,
            depth: r++
        });
        if (t !== n && !o) {
            const n = Zn(t);
            n?.error === void 0 && t.hasSlotProps() || (o = t);
        }
    }
    const i = {
        node: null,
        depth: -1
    };
    const c = n.children;
    if (c) {
        for (let n = 0; n < c.length; n++) {
            Kn(t, c[n], s, i);
        }
    }
    if (i.node) {
        const s = i.node.parentComponent;
        if (i.node === n) {
            t.Nt(o);
        } else if (s?.id) {
            t.Nt(s);
            e.projectedContentOwner = s;
        }
    }
}

function Zn(t) {
    const n = t.getProp(br);
    return n ? oi(n, Af.id, 0) : null;
}

function Kn(t, n, e, s) {
    n.vnodeData[0] |= 32;
    const o = n.getProp(ar);
    if (o) {
        const t = e.get(o);
        if (t) {
            t.node.removeProp(n.getProp(fr) ?? "");
            if (t.depth > s.depth) {
                s.node = t.node;
                s.depth = t.depth;
            }
        }
    }
    Pn(t, n);
    const r = n.getProp(Xr);
    if (r) {
        for (let n = 0; n < r.length; n++) {
            const e = r[n];
            qu(e) && Pn(t, e);
        }
    }
    const i = n.children;
    if (i) {
        for (let n = 0; n < i.length; n++) {
            Kn(t, i[n], e, s);
        }
    }
}

const Qc = () => ga;

const Hc = async t => {
    const [n, e] = ga;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = Nn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Jc = (t, n) => {
    const {val: e, set: s, iCtx: o} = zo();
    if (e) {
        return e;
    }
    const r = Ta(null, "_rsc", Hc, null, [ t, {} ], o.$);
    const i = As(r, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Yc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (fi(t)) {
        return t.then(n, s);
    }
    const o = Gc(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s) {
        const t = r.error ?? r.Wt;
        if (t) {
            return s(t);
        }
    }
    const i = o ? r.value?.r : r.value;
    return fi(i) ? i.then(n, s) : n(i);
};

const Gc = t => t && t.__brand === "resource";

function te(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        !n._t.startsWith("_") && (Array.isArray(n.Ct) || s && n.Ot) && (n = Ta(null, "_run", C, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = Ln(t, n, !0);
            const r = `${e}#${s}`;
            if (!o) {
                return r;
            }
            const i = [ r, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            i.push(" ");
                            i.push({
                                id: n,
                                base: c
                            });
                        } else {
                            i.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return i;
        }(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (sr(o)) {
                i(c(o));
                ne(t, n, o);
            } else if (o != null) {
                const e = te(t, n, o, s);
                e && i(e);
            }
        }
    } else if (sr(r)) {
        o = c(r);
        ne(t, n, r);
    }
    return o;
}

function ne(t, n, e) {
    const s = Ii(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.jt.add(r);
        t.Lt.add(e);
    }
}

const Zc = (t, n, e) => {
    nf(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Kc = (t, n, e) => {
    nf(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const tf = (t, n, e) => {
    nf(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const nf = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = ef();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + qi(i), e, s);
            }
        } else {
            r(t + qi(n), e, s);
        }
    }
};

const ef = () => {
    const t = ra();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Ur);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Ur, s);
    }
    let o = t.$.getHostProp(e, Br);
    o === null && (o = 0);
    t.$.setHostProp(e, Br, o + 1);
    let r = t.$.getHostProp(e, Qr);
    if (r === null) {
        r = [];
        t.$.setHostProp(e, Qr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const rf = function(t, n) {
    const e = Ie(n);
    return Gf(e, () => {
        typeof this === "string" && Ea(Sa(e, this));
        const s = ga?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const r = ga?.[0];
        if (!r || r.flags & 32) {
            return;
        }
        vn(e, r, 4);
        const i = n.ownerDocument;
        i.__hmrDone = i.__hmrT;
    });
};

let sf;

function ee(t) {
    const n = na();
    if (!n) {
        return;
    }
    sf ||= Mc(rf, "_hmr");
    const e = n._;
    const s = sf.w([ e, t ]);
    Kc("qHmr", s);
}

function re(t, n, e, s, o) {
    const r = $l();
    Sl(r, fr, o);
    r.parent = n;
    Sl(n, o, r);
    Sl(r, or, e);
    Sl(r, Fr, s);
    r.dirty = 4;
    pn(t, r, 1);
    return r;
}

function ie(t, n) {
    Sl(t, ur, n);
    t.flags |= 2048;
}

function se(t, n, e) {
    Sl(n, Fr, e);
    vn(t, n, 4);
}

function oe(t, n, e, s) {
    Sl(n, s, null);
    const o = [];
    kt(t, o, e);
    Ll(o);
    if (e.flags & 2048) {
        const t = El(e, ur, null);
        t && t.replaceChildren();
        Sl(e, ur, null);
        e.flags &= -2049;
    }
}

let of = Promise.resolve();

const lf = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const uf = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !lf.has(t));
};

function* le(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ce(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ue(t, n, e = Array(n.length / 2)) {
    const s = Tc(t);
    const o = n.length / 2;
    const r = new Uint8Array(o);
    const i = t.k;
    const c = s => {
        if (!r[s]) {
            r[s] = 1;
            const o = s * 2;
            const i = n[o];
            const c = n[o + 1];
            e[s] = i === 0 ? c : qc(t, i, c);
        }
        return e[s];
    };
    t.k = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const r = n[o];
            const i = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            cf(r) && (yield* fe(t, c, r, i));
            yield;
        }
    } finally {
        t.k = i;
        Ac(t, s);
    }
    return e;
}

function* ce(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = qc(t, n, e);
    cf(n) && (yield* fe(t, s, n, e));
    return s;
}

function* fe(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* le(t, s));
    switch (e) {
      case 4:
        yield* le(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!uf(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = Rc.get(t);
            if (e) {
                if (Rc.has(o)) {
                    throw er(37);
                }
                r(o);
            } else {
                i(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                uf(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t.bt = e[0];
            t.h = e[1];
            t.Ft = e[2];
            t.ht = e[3];
            break;
        }

      case 29:
        n[Da][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.Xt = e[0];
            t.ft = new Set(e.slice(1));
            he(t.ft, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.lt = t.getSyncFn(o[0]);
            e.ut = o[1];
            e.Xt = ls;
            e.h = o[2];
            e.h |= 1;
            e._ = o[3];
            e.ft = new Set(o.slice(4));
            (function r(t) {
                if (t._ !== null && yl(t._)) {
                    const n = t._;
                    const e = t.ft;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (tr(e)) {
                                const o = El(n, e, null);
                                if (o !== null) {
                                    t.Xt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Kl(n);
                        e && n.firstChild === n.lastChild && bl(e) && (t.Xt = Gl(e));
                    }
                }
            })(e);
            he(e.ft, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Dt = e[0];
            e[1] && (t.ft = new Set(e[1]));
            e[2] && (t.yt = new Set(e[2]));
            e[3] && (t.wt = new Set(e[3]));
            e[4] && (t.Wt = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Vt = !0);
            const o = e.length > 6;
            o && (t.Xt = e[6]);
            t.Xt === ls && (t.h |= 1);
            if (e[7] !== void 0 && e[7] !== 1) {
                t.zt = e[7] ?? 1;
                t.Ut = [];
            }
            t.Bt = e[8] ?? 0;
            he(t.ft, t);
            he(t.yt, t);
            he(t.wt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.Dt = r[0];
            const i = o.Dt.resolve(t).catch(() => {});
            of = of.finally(() => i);
            r[1] && (o.ft = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Xt = r[2]);
            e !== 34 && o.Xt !== ls && (o.h &= -2);
            he(o.ft, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === Yi) {
                o = new Vs(fo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[Qi] = o;
            const r = t[Hi];
            r.ft = e[3];
            de(r.ft, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.rt = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            ae(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            ae(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Qu(n);
            const o = t.Qt.get(e);
            if (o) {
                t.Qt.delete(e);
                yield* fe(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Vu(n);
            c.h = r;
            c.ft = i;
            de(c.ft, e);
            break;
        }

      default:
        throw er(16, [ e ]);
    }
}

function ae(t) {
    const n = Ve;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[yi] ||= new Map;
    e[yi].set(t.property, t);
}

function he(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function de(t, n) {
    if (t) {
        for (const [, e] of t) {
            he(e, n);
        }
    }
}

const cf = t => t >= 23 || t === 4 || t === 5;

const ff = new WeakMap;

const af = Symbol();

const hf = (t, n) => {
    if (!Array.isArray(n) || yl(n) || (t => Ze(t) && af in t)(n)) {
        return n;
    }
    let e = ff.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new df(t, n));
        ff.set(n, e);
    }
    return e;
};

class df {
    $;
    ze;
    constructor(t, n) {
        this.$ = t;
        this.ze = n;
    }
    get(t, n, e) {
        if (n === af) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.ze.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.ze[o];
        const i = this.ze[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.$;
        const l = Tc(c);
        try {
            const e = qc(c, r, i);
            Reflect.set(t, n, e);
            this.ze[o] = 0;
            this.ze[o + 1] = e;
            cf(r) && ((t, n, e, s) => {
                const o = Tc(t);
                try {
                    const o = fe(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    Ac(t, o);
                }
            })(c, e, r, i);
            return e;
        } finally {
            Ac(c, l);
        }
    }
    has(t, n) {
        if (n === af) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === af) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.ze.length / 2) {
            return o;
        }
        const i = r * 2;
        this.ze[i] = 0;
        this.ze[i + 1] = e;
        return !0;
    }
}

const pf = t => {
    if (!t.Ue) {
        t.Ue = !0;
        t.Be();
    }
};

const $f = (t, n, e) => {
    const s = {
        Qe: t,
        Be: void 0,
        Ue: !1
    };
    const o = il(() => {
        ((t, n, e) => {
            t.Ue = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.Qe.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        pf(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.zn?.();
            n(t);
        }, t => {
            o.zn?.();
            e(t);
        });
    });
    s.Be = o;
    return s;
};

async function pe(t) {
    const n = Dd(null, null, () => "", () => {}, new WeakMap);
    n.kt(t);
    await n.Ht();
    return n.Jt.toString();
}

async function $e(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = ve(n, () => e);
    s.Yt = e;
    await yf(ue(s, n, e));
    return e[0];
}

const yf = t => new Promise((n, e) => {
    const s = $f(t, n, e);
    pf(s);
});

function ye(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function we(t) {
    let n;
    const e = ve(t, () => n);
    n = hf(e, t);
    e.Yt = n;
    return e;
}

function ve(t, n) {
    const e = {
        k: t => ye(t, n()),
        Gt: t => e.Pt?.[+t],
        getSyncFn: () => () => {},
        $t: new WeakMap,
        element: null,
        Pt: null
    };
    Wn(t, e);
    return e;
}

const wf = (t, n) => {
    const e = new WeakSet;
    return sa(vf, t, e, "_", n);
};

const vf = (t, n, e, s) => {
    const o = Qu(t);
    if (o == null) {
        return t;
    }
    if (bf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Mu(o)) {
            return t;
        }
        if (bc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (fi(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Ke(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw er(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw er(3, [ o ]);
                    }
                    vf(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Mi) {
                return t;
            }
            if (Ge(o)) {
                for (const [t, s] of Object.entries(o)) {
                    vf(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw er(3, [ i ]);
    }
    return t;
};

const mf = /*#__PURE__*/ new WeakSet;

const bf = t => {
    if (Ze(t) || nr(t)) {
        return !mf.has(t) && !(Ef in t);
    }
    return !0;
};

const _f = t => !!t && (Ze(t) || typeof t === "function") && (mf.has(t) || Ef in t);

const gf = t => {
    (Ze(t) && t !== null || typeof t === "function") && mf.add(t);
    return t;
};

const Ef = Symbol();

const Sf = Symbol();

const kf = t => /*#__PURE__*/ Object.freeze({
    id: qi(t)
});

const Rf = (t, n) => {
    const {val: e, set: s, iCtx: o} = zo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o._, t, n);
    s(1);
};

const Pf = (t, n) => {
    const {val: e, set: s, iCtx: o} = zo();
    if (e !== void 0) {
        return e;
    }
    const r = o.$.resolveContext(o._, t);
    if (typeof n === "function") {
        return s(je(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw er(8, [ t.id ]);
};

const Tf = t => {
    const n = ea();
    const e = n._;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const Af = /*#__PURE__*/ kf("qk-error");

const qf = (t, n) => {
    try {
        return t();
    } catch {
        return n;
    }
};

const If = "An error occurred";

const Mf = t => To(qf(() => t instanceof Error ? `${t.name}: ${t.message}\n${t.stack ?? ""}` : t + "", "unknown"));

const xf = /*#__PURE__*/ Symbol();

const Nf = t => {
    const n = Error(If);
    n.digest = Mf(t);
    Object.defineProperty(n, xf, {
        value: !0
    });
    return n;
};

const Cf = t => {
    if (t instanceof Error) {
        return t;
    }
    let n;
    try {
        n = t + "";
    } catch {
        try {
            n = Object.prototype.toString.call(t);
        } catch {
            n = If;
        }
    }
    const e = Error(n);
    e.cause = t;
    return e;
};

const Of = (t, n, e) => {
    try {
        if (e) {
            const s = e(t);
            if (s instanceof Error) {
                return (t => qf(() => {
                    t.message;
                    t.name;
                    for (const n in t) {
                        t[n];
                    }
                    return !0;
                }, !1))(s) ? s : Nf(t);
            }
            if (s != null) {
                n && fi(s);
                return Nf(t);
            }
        }
        if (qf(() => t instanceof Error && xf in t, !1)) {
            return t;
        }
        if (!n) {
            return Nf(t);
        }
        if (t instanceof Error) {
            return t;
        }
        const s = t?.message;
        if (typeof s === "string") {
            const n = Error(s);
            n.cause = t;
            return n;
        }
        return Cf(t);
    } catch {
        return Nf(t);
    }
};

const jf = (t, n, e, s) => {
    if (!t) {
        return;
    }
    try {
        const o = Mf(n);
        Promise.resolve(t(Cf(n), {
            phase: e,
            boundaryId: s,
            digest: o
        })).catch(He);
    } catch (t) {
        He(t);
    }
};

const Lf = /*#__PURE__*/ new WeakSet;

const Ff = t => {
    Lf.add(t);
};

const Xf = /*#__PURE__*/ Symbol();

const Df = (t, n) => {
    try {
        Object.defineProperty(t, Xf, {
            value: n,
            configurable: !0
        });
    } catch {}
};

const Wf = (t, n, e = "render") => {
    t.error = n ?? Cf(n);
    const s = t.He;
    s && jf(s, n, (t => qf(() => t?.[Xf], void 0))(n) ?? e, t.boundaryId ?? "");
};

const Vf = t => {
    const n = t.detail;
    if (n?.importError) {
        return;
    }
    const e = n.element;
    if (!e || e.ownerDocument !== t.currentTarget) {
        return;
    }
    const s = e.closest(Ir)?.qContainer;
    const o = s?.vNodeLocate(e);
    if (!s || !o) {
        return;
    }
    try {
        s.handleError(n.error, o, "event");
    } catch (t) {
        He(t);
    }
};

function me(t, n) {
    const e = t.getHostProp(n, br);
    return e ? oi(e, Af.id, 0) : null;
}

const Vd = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const zd = new WeakMap;

class Ud {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = Bd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return Vd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const Bd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const Qd = () => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return !1;
    }
    const t = na()?.$;
    return t?.outOfOrderStreaming === !0 && !Fd(t);
};

const zf = (t, n, e, s, o) => {
    let r;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (r ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    r && ju(t, n, r);
};

const Uf = new WeakMap;

function* be(t, n) {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Zt}"]${dr}`);
    const o = Bf(t);
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (n !== void 0 && i.getAttribute(pr) !== n) {
            continue;
        }
        if (o.has(i)) {
            continue;
        }
        o.add(i);
        yield* _e(t, e, i.textContent);
        yield;
    }
}

const Bf = t => {
    let n = Uf.get(t);
    if (!n) {
        n = new WeakSet;
        Uf.set(t, n);
    }
    return n;
};

function* _e(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, r, i] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.Kt.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.Kt[e * 2 + t] = s[t];
            yield;
        }
        yield* Vn(n.Kt, t, e * 2);
        n.tn = hf(t, n.Kt);
        n.tn.length = n.Kt.length / 2;
        n.nn = n.Pt;
    }(t, n, s, o);
    Qf(n, r || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.pendingBoundary || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t.k(s.rootId);
            const r = s.subscriptions;
            if (o instanceof ys) {
                r instanceof Set && zf(t, o, o, o.ft ||= new Set, r);
            } else {
                if (!(r instanceof Map)) {
                    continue;
                }
                const n = Vu(o);
                const e = zu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ft ||= new Map;
                for (const [o, i] of r) {
                    let r = s.get(o);
                    if (!r) {
                        r = new Set;
                        s.set(o, r);
                    }
                    zf(t, n, e, r, i);
                }
            }
        }
    })(t, i === void 0 ? void 0 : n.k(i));
}

const Qf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.nn ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Pt = e;
};

const Hf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function ge(t, n) {
    const e = t.qVNodeDataState ||= {
        en: [],
        rn: null
    };
    t.qProcessVNodeDataPatch ||= n => ge(t, ke(t, n));
    t.qVNodeDataReady = !1;
    e.en.push(n);
    Ee(t, e);
}

function Ee(t, n) {
    if (n.rn) {
        return;
    }
    const e = n.en.shift();
    if (!e) {
        Se(t);
        return;
    }
    n.rn = $f(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.rn = null;
            Ee(t, n);
        }
    }, e => {
        n.rn = null;
        He(e);
        Se(t);
    });
    pf(n.rn);
}

function Se(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* ke(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* Re(t, s || void 0, e, o, n.textContent));
}

function* Re(t, n, e, s, o) {
    const r = "q:container";
    const i = "/" + r;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const r = __EXPERIMENTAL__.pendingBoundary && e.getAttribute("q:r");
            r ? (s.qSegmentVnodeData ||= new Map).set(r, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const b = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, r) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.pendingBoundary && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(r)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(i)) {
                return 8;
            }
        }
        return 0;
    };
    const _ = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const v = t => {
        let n = null;
        for (;t && !(n = _(t)); ) {
            t = t.parentNode;
        }
        return n;
    };
    const g = function*(n, e, s, o, r, i, c, l) {
        const u = __EXPERIMENTAL__.pendingBoundary && l !== void 0;
        const f = r.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let E = -1;
        let k = null;
        const R = () => {
            let t = 0;
            for (;Jf(m = r.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            k = null;
            const P = s == e ? 2 : b(s);
            if (P === 3) {
                const t = s;
                k = v(s);
                yield* g(n, t, s, k, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (P === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (P === 64) {
                k = s;
                let t;
                do {
                    k = n.nextNode();
                    if (!k) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(k);
                } while (t !== 32 && t !== 65);
                k = null;
            } else if (P === 9) {
                k = s;
                do {
                    k = _(k);
                    if (!k) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(k) !== 8);
                yield* g(n, s, s, k, "", null, c);
            } else if (P === 6) {
                k = _(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* g(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((P & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += R();
                        if (m === 126) {
                            E = p;
                            y++;
                            m = y < f ? r.charCodeAt(w) : 33;
                        }
                        w = Yf(r, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.pendingBoundary && !u && P === 130 ? $.call(s, a) : null;
                if (h === p) {
                    E !== h || u && s === e || i.set(u ? Ei(l, h) : h, s);
                    const t = r.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== gi || n.charCodeAt(1) !== gi || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        P !== 3 && d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.pendingBoundary && t !== null) {
                    yield* S(c, s, t);
                    k = _(s);
                    k && (n.currentNode = k);
                }
            }
            yield;
        } while (s = k || n.nextNode());
    };
    const E = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const r = t.createTreeWalker(t, 129);
        r.currentNode = e;
        yield* g(r, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const S = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* E(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.pendingBoundary && n !== void 0 ? yield* S(e, s, n, o) : yield* E(e, s, o);
        return;
    }
    yield* m(t);
    const k = t.createTreeWalker(t, 129);
    yield* g(k, null, k.firstChild(), null, "", null, null);
}

const Jf = t => 33 <= t && t <= 46;

const Yf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Jf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Pe(t) {
    return t.sn === 3;
}

function Te(t, n) {
    const e = t.ln ||= {
        en: [],
        rn: null
    };
    t.sn = 2;
    e.en.push(n);
    Ae(t, e);
}

const Gf = (t, n) => {
    const e = t;
    if (Pe(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!Pe(e)) {
                    (e.un ||= []).push(s);
                    return;
                }
                Hf(e.document, () => {
                    Pe(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function Ae(t, n) {
    if (n.rn) {
        return;
    }
    const e = n.en.shift();
    if (!e) {
        qe(t);
        return;
    }
    n.rn = $f(e, () => {
        n.rn = null;
        Ae(t, n);
    }, e => {
        n.rn = null;
        He(e);
        qe(t);
    });
    pf(n.rn);
}

function qe(t) {
    const n = t.sn;
    if (n !== 2) {
        return;
    }
    t.sn = 3;
    t.ln = void 0;
    const e = t.un;
    t.un = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Ie(t) {
    const n = xe(t);
    if (!n) {
        throw er(24);
    }
    return Me(n);
}

function Me(t) {
    const n = t;
    return n.qContainer ||= new Zf(n);
}

function xe(t) {
    return t.closest(Ir);
}

function Ne(t, n) {
    const e = t + "";
    const s = n?.closest(Ir);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.pendingBoundary || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const r = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            ge(t, function* i(t, n, e, s, o, r) {
                yield* Re(t, n, e, s, o);
                for (let n = 0; n < r.length; n++) {
                    yield* ke(t, r[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, r));
        })(t, e, n);
        Hf(t, () => {
            o.element.qContainer === o && Te(o, be(o, e));
        });
    }
}

class Zf extends Dc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    $t=new WeakMap;
    Je;
    Zt;
    Pt=null;
    vNodeLocate=t => Ml(this.rootVNode, t);
    sn=0;
    un=void 0;
    ln=void 0;
    Kt;
    tn;
    nn=null;
    Ye=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Tr);
        if (!this.qContainer) {
            throw er(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.Ve = t.getAttribute(Er);
        this.Zt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = dl(this.element);
        this.Kt = [];
        this.tn = [];
        __EXPERIMENTAL__.pendingBoundary && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= Ne);
        this.Je = gr(n, this.Zt) || Gi;
        this.Ge();
        t.qContainer = this;
        t.qDestroy = () => this.zn();
        __EXPERIMENTAL__.catchBoundary && function e(t) {
            if (!t.qErrorHandler) {
                t.qErrorHandler = Vf;
                t.addEventListener?.("qerror", Vf);
            }
        }(this.document);
        this.sn = 1;
        (function s(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            ge(e, function* s(t) {
                yield* Re(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Hf(n, () => {
            this.sn === 1 && Te(this, this.Ze());
        });
    }
    * Ze() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Zt}"]:not(${dr})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${dr})`);
        if (n) {
            this.Kt = JSON.parse(n.textContent);
            yield* Vn(this.Kt, this);
            this.nn = this.Pt;
            const e = this.Kt.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.tn = s !== null && e > 0 && e >= +s ? yield* ue(this, this.Kt) : hf(this, this.Kt);
        }
        __EXPERIMENTAL__.pendingBoundary && (yield* be(this));
        this.Ke();
        t.setAttribute(Tr, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    zn() {
        this.vNodeLocate = () => null;
        this.Kt.length = 0;
        this.tn.length = 0;
        this.k = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.pendingBoundary && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Tr);
        const n = t.ownerDocument;
        this.ln = void 0;
        this.sn = 0;
        const e = n.querySelector(Ir) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.pendingBoundary && (e || (n.qProcessOOOS = void 0));
    }
    Ke() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(vr);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Qn(t, n) {
        this.tn[t] = n;
    }
    parseQRL(t) {
        return Xn(t, this);
    }
    handleError(t, n, e = "render") {
        if (!__EXPERIMENTAL__.catchBoundary) {
            const e = n && this.resolveContext(n, Af);
            if (!e) {
                Je(t);
                return;
            }
            e.error = t;
            return;
        }
        const s = t ?? Cf(t);
        let o = n;
        for (;o; ) {
            const n = this.resolveContextHost(o, Af);
            if (!n) {
                break;
            }
            const r = me(this, n);
            if (r && r.error === void 0) {
                r.error = s;
                const o = this.getHostProp(n, Fr);
                jf(o?.onError$, t, e, r.boundaryId ?? "");
                vn(this, n, 4);
                return;
            }
            if (n.dirty & 4) {
                He(t);
                return;
            }
            o = this.getParentHost(n);
        }
        Je(t);
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, br);
        s == null && this.setHostProp(t, br, s = []);
        si(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        const e = this.resolveContextHost(t, n);
        return e ? oi(this.getHostProp(e, br), n.id, 0) : void 0;
    }
    resolveContextHost(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, br);
            if (e != null && li(e, n.id, 0)) {
                return t;
            }
            t = this.getParentHost(t);
        }
        return null;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (_l(n)) {
                if (El(n, or, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        Sl(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Xr:
          case Fr:
          case or:
          case br:
          case _r:
            s = this.k;
            break;

          case Dr:
          case Br:
            s = parseInt;
            break;
        }
        return El(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (S(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    k=t => ye(t, this.tn);
    Gt(t) {
        return this.nn?.[t];
    }
    getSyncFn(t) {
        const n = this.Je[t];
        return n;
    }
    tr(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, mr);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, mr, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ye == null) {
            this.Ye = new Set;
            const t = this.document.querySelectorAll(wr);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ye.add(e.getAttribute(yr));
            }
        }
        if (!this.Ye.has(n)) {
            this.Ye.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(yr, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ge() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === Yr) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.dn = {
            containerAttributes: t
        };
    }
}

let Kf;

let Hd;

if (Ve) {
    const t = Be();
    t && (Hd = new t);
}

function Ce(t) {
    if (Hd) {
        const t = Hd.getStore();
        if (t) {
            return t;
        }
    }
    if (Kf === void 0) {
        const n = na();
        if (n && n.cn) {
            return n.cn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Kf;
}

function Oe(t, n) {
    if (Hd) {
        return Hd.run(t, n);
    }
    const e = Kf;
    const s = () => {
        Kf = e;
    };
    Kf = t;
    return ai(n, t => {
        s();
        return t;
    }, t => {
        s();
        throw t;
    });
}

let ta;

const na = () => ta;

const ea = () => {
    const t = na();
    if (!t) {
        throw er(9);
    }
    return t;
};

const ra = () => {
    const t = na();
    if (!t || t.fn !== Cr) {
        throw er(10);
    }
    return t;
};

function je(t, n, ...e) {
    return Le.call(this, t, n, e);
}

function Le(t, n, e) {
    const s = ta;
    try {
        ta = t;
        return n.apply(this, e);
    } finally {
        ta = s;
    }
}

const ia = (t, n, e = Ie(n)) => {
    const s = Ml(e.rootVNode, n);
    const o = e.cn;
    o && function r(t) {
        if (Hd) {
            Hd.enterWith(t);
            return;
        }
        Kf = t;
    }(o);
    const i = Xe(o, s, t);
    i.$ = e;
    return i;
};

function Fe(t, n, e) {
    const s = {
        _: n,
        fn: Cr,
        an: void 0,
        cn: t,
        $: e,
        hn: void 0
    };
    return s;
}

function Xe(t, n, e) {
    const s = {
        _: n,
        fn: e,
        an: void 0,
        cn: t,
        $: void 0
    };
    return s;
}

const sa = (t, ...n) => {
    if (typeof t === "function") {
        if (!ta) {
            return t(...n);
        }
        {
            const e = ta.an;
            try {
                ta.an = void 0;
                return t(...n);
            } finally {
                ta.an = e;
            }
        }
    }
    if (Mu(t)) {
        return t.untrackedValue;
    }
    return Qu(t);
};

const oa = /*#__PURE__*/ Fe(void 0, void 0, void 0);

const la = (t, n, e, s, o) => {
    const r = oa.an;
    const i = oa.$;
    try {
        oa.an = w(n, e, o);
        oa.$ = s;
        return Le(oa, t);
    } finally {
        oa.an = r;
        oa.$ = i;
    }
};

const ua = (t, n, e, s, o) => {
    t instanceof Xs && t._ !== n && n && (t._ = n);
    return la(() => t.value, n, e, s, o);
};

const ca = () => na()?._;

const fa = () => {
    const t = na();
    if (t) {
        return t.fn;
    }
};

const aa = () => {
    const t = na();
    if (t) {
        return t.$;
    }
};

const ha = t => t;

const da = t => t.l || Promise.resolve();

let pa;

class $a {
    gt;
    _t;
    nr;
    er;
    $;
    constructor(t, n, e, s, o) {
        this.gt = t;
        this._t = n;
        this.nr = e;
        this.er = s;
        s && this.rr(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        ze && t && We(t, .8);
    }
    get ot() {
        return Od(this._t);
    }
    rr(t) {
        this.er = t;
        fi(t) && t.then(t => this.er = t, t => {
            const n = `qrl ${this._t} failed to load`;
            if (Ve) {
                console.error(n, t);
            } else if (ze) {
                const e = this.gt === null ? "symbol:" + this._t : "chunk:" + this.gt;
                const s = this.$;
                let o = s && pa?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (pa ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.er = null;
        });
    }
    ir() {
        if (this.er != null) {
            return this.er;
        }
        if (this.gt === "") {
            const t = this.$.Zt;
            const n = this.$.element?.ownerDocument || document;
            const e = gr(n, t);
            return this.er = e[+this._t];
        }
        ze && this.gt && We(this.gt, 1);
        const t = this._t;
        const n = this.nr ? this.nr().then(n => n[t]) : ri().importSymbol(this.$?.element, this.gt, t);
        this.rr(n);
        return this.er;
    }
}

const ya = Symbol();

const wa = t => t?.[ya] ?? t;

class va {
    sr;
    resolved=void 0;
    Ct;
    $;
    constructor(t, n, e) {
        this.sr = t;
        if (n) {
            this.Ct = n;
            typeof n === "string" && (this.$ = e);
        }
        t.er == null || this.Ct && typeof this.Ct === "string" || fi(t.er) || (this.resolved = Ra(this, t.er));
    }
}

const ma = function(t, ...n) {
    const e = wa(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = na();
    return ba.call(e, s?.$).then(() => Le.call(t, s, e.resolved, n));
};

const ba = async function(t) {
    const n = wa(this);
    return hi(Pa(n, t), () => n.resolved);
};

const _a = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[ya].resolved;
        },
        set(t) {
            this[ya].resolved = t;
        }
    },
    Ct: {
        get() {
            return this[ya].Ct;
        },
        set(t) {
            this[ya].Ct = t;
        }
    },
    Ot: {
        get() {
            return this[ya].sr.Ot;
        }
    },
    $: {
        get() {
            return this[ya].$;
        },
        set(t) {
            this[ya].$ = t;
        }
    },
    sr: {
        get() {
            return this[ya].sr;
        }
    },
    gt: {
        get() {
            return this[ya].sr.gt;
        }
    },
    _t: {
        get() {
            return this[ya].sr._t;
        }
    },
    ot: {
        get() {
            return this[ya].sr.ot;
        }
    },
    dev: {
        get() {
            return this[ya].sr.dev;
        }
    },
    lr: {
        value: ma
    },
    w: {
        value: function(t) {
            const n = wa(this);
            const e = new va(n.sr, t, n.Ct ? n.$ : void 0);
            return Aa(e);
        }
    },
    m: {
        value: function() {
            this[ya].sr.Ot = !0;
            return this;
        }
    },
    s: {
        value: function(t) {
            const n = wa(this);
            n.sr.rr(t);
            n.resolved = Ra(n, t);
        }
    },
    resolve: {
        value: ba
    },
    getSymbol: {
        value: function() {
            return wa(this).sr._t;
        }
    },
    getHash: {
        value: function() {
            return wa(this).sr.ot;
        }
    },
    getCaptured: {
        value: function() {
            const t = wa(this);
            ka(t);
            return t.Ct;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = wa(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return ba.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Le(t, e.resolved, o);
            };
            return s;
        }
    }
});

let ga = null;

const Ea = t => {
    ga = t;
};

const Sa = (t, n, e = 0, s) => {
    const o = [];
    let r = s;
    let i = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > i) {
                const e = +n.slice(i, s);
                r = r === void 0 ? e : r + e;
                o.push(t.k(r));
            }
            i = s + 1;
        }
    }
    return o;
};

const ka = t => {
    const n = t.Ct;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw er(13);
        }
        const s = of;
        ga = t.Ct = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return Sa(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return Sa(t, n, s + 1, o);
        })(e, n);
        if (of !== s) {
            return of;
        }
    } else {
        ga = n || null;
    }
};

const Ra = (t, n) => {
    if (typeof n !== "function" || !t.Ct) {
        return n;
    }
    return function e(...s) {
        ka(t);
        return n.apply(this, s);
    };
};

const Pa = (t, n) => {
    const e = t.sr;
    const s = typeof t.Ct === "string";
    s && !t.$ && (t.$ = n || na()?.$);
    if (t.resolved) {
        return;
    }
    const o = xa();
    const r = na();
    const i = e.ir();
    const c = hi(i, n => {
        t.resolved = Ra(t, n);
    });
    if (c) {
        const t = e._t;
        Ia(t, r?._ instanceof Ni ? r?._.node : void 0, o);
    }
    const l = s && t.$ && ka(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Ta = (t, n, e, s, o, r) => {
    const i = ((t, n, e, s, o) => new $a(t, n, e, s, o))(t, n, s, e, r);
    const c = new va(i, o, r);
    return Aa(c);
};

const Aa = t => {
    const n = async function(...t) {
        return ma.call(n, this, ...t);
    };
    n[ya] = t;
    Object.setPrototypeOf(n, _a);
    return n;
};

const qa = /*#__PURE__*/ new Set;

const Ia = (t, n, e) => {
    if (!qa.has(t)) {
        qa.add(t);
        Ma("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Ma = (t, n) => {
    jd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const xa = () => {
    if (jd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Na = 0;

const Ca = t => Ta(null, "s" + Na++, t, null, null);

const Oa = Ca;

const ja = t => t;

const La = t => Ta("", ir, t, null, null);

const Fa = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return Ta("", ir, t, null, null);
};

const Xa = t => {
    function n(n, e, s = 0) {
        const o = t.ot.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Da] = [ t ];
        return eo(i, n, null, n.children, s, r);
    }
    n[Da] = [ t ];
    return n;
};

const Da = Symbol();

const Wa = t => typeof t == "function" && t[Da] !== void 0;

const Va = t => Xa(Oa(t));

const za = Ss(ja);

const Ua = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const Ba = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !ui(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Tr, "resumed");
    const s = Ie(t);
    s.dn = e.serverData || {};
    const o = s.rootVNode;
    Sl(o, Xi, n);
    vn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            kt(s, [], s.rootVNode);
        }
    };
};

const Qa = (t, n) => {
    const {val: e, set: s, iCtx: o} = zo();
    if (e != null) {
        return e;
    }
    const r = nr(t) ? je(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = Ju(r, i, t);
        s(c);
        return c;
    }
};

const Ha = t => {
    const n = $i(t);
    return (t => t.toString(36))(n.We++);
};

const Ja = () => {
    const {val: t, set: n, iCtx: e} = zo();
    if (t != null) {
        return t;
    }
    const s = e.$.Ve || "";
    const o = s ? To(s).substring(0, 3) : "";
    const r = e.$.getHostProp(e._, or);
    const i = r?.getHash().substring(0, 3) || "";
    const c = Ha(e.$) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function De(t, n) {
    const e = na();
    return e?.$?.dn[t] ?? n;
}

const Ya = /*#__PURE__*/ new Map;

const Ga = (t, n) => {
    let e = Ya.get(n);
    e || Ya.set(n, e = Za(t, n));
    return e;
};

const Za = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = rh;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === Lh) {
            r++;
            e = Nh;
        }
        const s = Bh[c];
        for (let p = 0; p < s.length; p++) {
            const $ = s[p];
            const [y, w, m] = $;
            if ((y === l || y === dh || y === ph && Ka(l) || y === yh && eh(l)) && (w === e || w === dh || w === ph && Ka(e) || w === $h && !Ka(e) && e !== Th || w === yh && eh(e))) {
                const s = r;
                if ($.length == 3 || a($)) {
                    if (c === fh && m === sh && !h()) {
                        r = s;
                        continue;
                    }
                    $.length > 3 && (e = t.charCodeAt(r - 1));
                    if (m === ah || m == hh) {
                        if (m === hh) {
                            if (c !== ih || d()) {
                                if (!th(e)) {
                                    const t = w == $h ? 1 : w == kh ? 2 : 0;
                                    f(r - t);
                                }
                            } else {
                                th(e) ? u(r - 2) : f(r - 2);
                                i++;
                            }
                        }
                        if (w === $h) {
                            r--;
                            e = l;
                        }
                        do {
                            c = o.pop() || rh;
                            if (c === sh) {
                                u(r - 1);
                                i++;
                            }
                        } while (nh(c));
                    } else {
                        o.push(c);
                        if (c === sh && m === rh) {
                            u(r - 8);
                            i = r;
                        } else {
                            m === oh && f(n);
                        }
                        c = m;
                    }
                    break;
                }
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === sh || d()) {
            return;
        }
        u(t);
        s.push(".", cr, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Ph) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Ph) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Xh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        let n = r;
        let s = 0;
        let o = 0;
        let i = 0;
        for (;n < e; ) {
            const e = t.charCodeAt(n++);
            if (i) {
                e === Lh ? n++ : e === i && (i = 0);
            } else if (e === Eh || e === _h) {
                i = e;
            } else if (e === Ah && t.charCodeAt(n) === Rh) {
                n = t.indexOf("*/", n + 1);
                if (n === -1) {
                    return !1;
                }
                n += 2;
            } else if (e === Sh) {
                s++;
            } else if (e === kh) {
                s--;
            } else if (e === Oh) {
                o++;
            } else if (e === jh) {
                o--;
            } else if (s === 0 && o === 0) {
                if (e === Vh) {
                    return !0;
                }
                if (e === xh || e === zh) {
                    return !1;
                }
            }
        }
        return !1;
    }
    function d() {
        return o.indexOf(sh) !== -1 || o.indexOf(lh) !== -1;
    }
};

const Ka = t => t >= qh && t <= Ih || t >= Nh && t <= Ch || t >= Dh && t <= Wh || t >= 128 || t === Fh || t === Ph;

const th = t => t === Mh || t === Th || t === Oh || t === gh || Ka(t);

const nh = t => t === uh || t === lh || t === ch || t === sh;

const eh = t => t === bh || t === wh || t === vh || t === mh;

const rh = 0;

const ih = 2;

const sh = 5;

const oh = 6;

const lh = 10;

const uh = 11;

const ch = 12;

const fh = 13;

const ah = 17;

const hh = 18;

const dh = 0;

const ph = 1;

const $h = 2;

const yh = 3;

const wh = 9;

const vh = 10;

const mh = 13;

const bh = 32;

const _h = 34;

const gh = 35;

const Eh = 39;

const Sh = 40;

const kh = 41;

const Rh = 42;

const Ph = 45;

const Th = 46;

const Ah = 47;

const qh = 48;

const Ih = 57;

const Mh = 58;

const xh = 59;

const Nh = 65;

const Ch = 90;

const Oh = 91;

const jh = 93;

const Lh = 92;

const Fh = 95;

const Xh = 32;

const Dh = 97;

const Wh = 122;

const Vh = 123;

const zh = 125;

const Uh = /*@__PURE__*/ (() => [ [ dh, Eh, 14 ], [ dh, _h, 15 ], [ dh, Ah, 16, "*" ] ])();

const Bh = /*@__PURE__*/ (() => [ [ [ dh, Rh, ih ], [ dh, Oh, 7 ], [ dh, Mh, oh, ":", "before", "after", "first-letter", "first-line" ], [ dh, Mh, sh, "global" ], [ dh, Mh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ dh, Mh, 4 ], [ dh, ph, 1 ], [ dh, Th, 1 ], [ dh, gh, 1 ], [ dh, 64, lh, "keyframe" ], [ dh, 64, uh, "media", "supports", "container" ], [ dh, 64, ch ], [ dh, Vh, fh ], [ Ah, Rh, 16 ], [ dh, xh, ah ], [ dh, zh, ah ], [ dh, kh, ah ], ...Uh ], [ [ dh, $h, hh ] ], [ [ dh, $h, hh ] ], [ [ dh, Sh, rh ], [ dh, $h, hh ] ], [ [ dh, Sh, 8 ], [ dh, $h, hh ] ], [ [ dh, Sh, rh ], [ dh, $h, ah ] ], [ [ dh, $h, ah ] ], [ [ dh, jh, hh ], [ dh, Eh, 14 ], [ dh, _h, 15 ] ], [ [ dh, kh, ah ], ...Uh ], [ [ dh, zh, ah ], ...Uh ], [ [ dh, zh, ah ], [ yh, ph, 1 ], [ dh, Mh, sh, "global" ], [ dh, Vh, fh ], ...Uh ], [ [ dh, Vh, rh ], [ dh, xh, ah ], ...Uh ], [ [ dh, xh, ah ], [ dh, Vh, 9 ], ...Uh ], [ [ dh, zh, ah ], [ dh, Vh, fh ], [ dh, Mh, sh, "global" ], [ dh, Sh, 8 ], ...Uh ], [ [ dh, Eh, ah ] ], [ [ dh, _h, ah ] ], [ [ Rh, Ah, ah ] ] ])();

const Qh = t => ({
    styleId: Gh(t, t => t, !1)
});

const Hh = /*#__PURE__*/ Ss(Qh);

const Jh = t => ({
    scopeId: cr + Gh(t, Ga, !0)
});

const Yh = /*#__PURE__*/ Ss(Jh);

const Gh = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = zo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${To(t.ot)}-${n}`)(t, i);
    const l = r._;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.$.tr(n(t, c), c, l, e));
    }
    r.$.tr(n(t.resolved, c), c, l, e);
    return c;
};

const Zh = (t, n) => {
    t.resolve();
    return Ts(t, n);
};

const Kh = (t, n) => Qo(Zh, t, n);

const td = Ss(Kh);

const nd = t => {
    t.resolve();
    return qs(t);
};

const ed = t => Qo(nd, t);

const rd = Ss(ed);

const id = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = zo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !jd()) {
            e.h |= 32;
            sd(e, i);
        }
        return;
    }
    let c;
    if (jd() || i === "intersection-observer") {
        c = 1;
        jd() || t.resolve();
    } else {
        c = 5;
        t.resolve();
        vn(r.$, r._, 1);
    }
    const l = new Au(c, o, r._, t, null);
    s(l);
    sd(l, i);
};

const sd = (t, n) => {
    n === "intersection-observer" ? Zc("qvisible", od(t)) : n === "document-ready" ? Kc("qinit", od(t)) : n === "document-idle" && Kc("qidle", od(t));
};

const od = t => Ta(null, "_task", Mn, null, [ t ]);

const ld = Ss(Jc);

const ud = /*#__PURE__*/ Ss(Pu);

const cd = /*#__PURE__*/ Ss(id);

const fd = () => Object.defineProperty({
    error: void 0
}, "error", {
    enumerable: !1
});

async function Jd(t, n, e, s) {
    const o = n + "";
    const r = await e.container.S(o, e);
    t.write(`<template ${pr}="${n}"${s?.attrs ?? ""}>`);
    t.write(r.html);
    t.write("</template>");
    t.emitOutOfOrderSegmentScripts(r.scripts);
    t.emitOutOfOrderExecutorIfNeeded();
    t.emitInlineScript(`qO(${n})`);
    const i = e.container.P;
    if (__EXPERIMENTAL__.catchBoundary && i?.length) {
        t.emitErrorSwapExecutorIfNeeded();
        for (let n = 0; n < i.length; n++) {
            t.emitInlineScript(`qErr(${i[n]})`);
        }
    }
    await t.streamHandler.flush();
}

const ad = () => {
    const [t] = ga;
    const n = na()?.$;
    const e = ze;
    e && t && n && function s(t, n) {
        const e = t.resolveContextHost(n, Af);
        if (!e) {
            return;
        }
        const s = me(t, e);
        if (!s) {
            return;
        }
        (t => {
            const n = ps(t);
            const e = n && ds.get(n);
            return e && e.Wt !== void 0 ? e : void 0;
        })((zu(s) ?? s).error)?.invalidate();
        (function o(t, n, e) {
            let s = n;
            let o = null;
            let r = mu(n);
            let i = !1;
            for (;r; ) {
                if (_l(r)) {
                    if (El(r, fr, null) !== null) {
                        i = !0;
                    } else if (El(r, or, null) !== null) {
                        if (!i) {
                            const n = me(t, r);
                            if (!n || n.error !== void 0) {
                                o && (s = o);
                                o = r;
                                if (n?.error !== void 0 || !k(r.props)) {
                                    break;
                                }
                            }
                        }
                        i = !1;
                    }
                }
                r = mu(r);
            }
            if (e && e !== o) {
                s = o ?? s;
                o = e;
            }
            if (o) {
                s.key = `${s.key ?? ""}${hd}`;
                vn(t, o, 4);
            } else {
                vn(t, n, 4);
            }
        })(t, e, s.projectedContentOwner ?? null);
        s.error = void 0;
    }(n, t);
};

const hd = "\0";

const dd = t => {
    if (!__EXPERIMENTAL__.catchBoundary) {
        throw Error('<Catch> requires the `catchBoundary` experimental feature. Enable it in your Qwik Vite config: qwikVite({ experimental: ["catchBoundary"] }).');
    }
    const n = (() => {
        const t = Qa(fd);
        Rf(Af, t);
        return t;
    })();
    const e = na();
    const s = e?.$;
    s && (zu(n) ?? n).boundaryId === void 0 && (n.boundaryId = Ha(s));
    const o = !ze;
    if (!o && n.error === void 0) {
        return /* @__PURE__ */ no(ho, null, null, null, 0, null);
    }
    const r = /*#__PURE__*/ Mc(ad, "_caR", [ e?._ ]);
    if (o) {
        const e = t.fallback$;
        n.qt = gf(t => e(t, r));
        const o = t.onError$;
        o && (n.He = gf((t, n) => o(t, n)));
        return ((t, n) => {
            const e = n?.nextOutOfOrderId(!1) ?? 0;
            return [ 
            /*#__PURE__*/ no("div", {
                [$r]: e + "",
                style: "display:contents"
            }, null, 
            /*#__PURE__*/ no(ho, null, null, null, 0, null), 1, null), 
            /*#__PURE__*/ no(Zd, {
                boundaryId: e,
                store: t
            }, null, null, 1, null) ];
        })(n, s);
    }
    const i = Of(n.error, !0);
    return /* @__PURE__ */ no(fo, null, null, ((t, n, e) => t(n, e).catch(n => {
        if (t.resolved !== void 0) {
            throw n;
        }
        return /* @__PURE__ */ no("div", {
            role: "alert"
        }, null, "Something went wrong.", 0, null);
    }))(t.fallback$, i, r), 0, null);
};

const pd = /*#__PURE__*/ Xa(
/*#__PURE__*/ Mc(dd, "_caC"));

const Yd = (t, n) => {
    const e = n.qt;
    delete n.qt;
    const s = Of(n.error, Ue, t.I);
    return e(s);
};

const Gd = __EXPERIMENTAL__.catchBoundary ? /*#__PURE__*/ Wd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    if (n.varProps.deliverLate) {
        const n = async n => {
            if (!r.qt) {
                return;
            }
            r.error !== n && Wf(r, n, "render");
            const s = await t.segment("" + o, Yd(t, r), e);
            s.container.A(o);
            await t.C(() => Jd(t, o, s, null));
        };
        r.Mt = gf(n);
        t.write(`<template ${pr}="${o}"></template>`);
        if (r.error !== void 0) {
            return n(r.error);
        }
        return;
    }
    if (r.error === void 0 || !r.qt) {
        return;
    }
    Fd(t) ? t.A(o) : s(() => {
        t.emitErrorSwapExecutorIfNeeded();
        t.emitInlineScript(`qErr(${o})`);
    });
    s(Yd(t, r));
}) : null;

const Zd = __EXPERIMENTAL__.catchBoundary ? /*#__PURE__*/ Wd((t, n, e, s) => {
    const o = n.varProps.boundaryId;
    const r = n.varProps.store;
    const i = __EXPERIMENTAL__.pendingBoundary && t.outOfOrderStreaming && !Fd(t) && (r.error === void 0 || (t => Lf.has(t))(r));
    s(
    /*#__PURE__*/ no("div", {
        [i ? Ld : "q:cf"]: o + "",
        style: "display:none"
    }, null, 
    /*#__PURE__*/ no(Gd, {
        boundaryId: o,
        store: r,
        deliverLate: i
    }, null, null, 1, null), 1, null));
}) : null;

const $d = async ({track: t}) => {
    const n = ga[0];
    t(() => n.items);
    const e = na();
    const s = e._;
    const o = e.$;
    const r = vn(o, s, 256);
    const i = Ve;
    i && await r;
};

const yd = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Pu(/*#__PURE__*/ Mc($d, "_eaT", [ t ]));
    return po;
};

const wd = /*#__PURE__*/ Xa(
/*#__PURE__*/ Mc(yd, "_eaC"));

const vd = (t, n, e) => sr(t) ? t.getFn(n)(e) : t(e);

const md = ({track: t}) => {
    const n = ga[0];
    const e = na();
    const s = e._;
    const o = e.$;
    const r = Ve;
    return hi(t(() => vd(n.when$, na(), void 0)), t => {
        const i = t ? n.then$ : n.else$;
        return hi(i ? vd(i, e, t) : null, t => {
            const n = i ? [ t ] : [];
            if (r) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Bt(s, n);
            vn(o, s, 2);
        });
    });
};

const bd = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Pu(/*#__PURE__*/ Mc(md, "_shT", [ t ]));
    return po;
};

const _d = /*#__PURE__*/ Xa(
/*#__PURE__*/ Mc(bd, "_shC"));

const gd = /*#__PURE__*/ kf("qk-reveal");

const Ed = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Is(0)
});

const Sd = () => {
    const t = ga[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!ze) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return Vd(t);
};

const kd = ({cleanup: t}) => {
    const n = ga[0];
    t(() => {
        if (!ze) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Rd = t => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
    }
    const n = Qo(Ed, t);
    Rf(gd, n);
    const e = !ze;
    if (__EXPERIMENTAL__.pendingBoundary && e && Qd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = na().$;
                const s = (zd.get(e) || 0) + 1;
                zd.set(e, s);
                return new Ud(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = gf(e);
            return e;
        })(n);
        return /* @__PURE__ */ no(Kd, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    return /* @__PURE__ */ no(ho, null, null, null, 0, "u7_0");
};

const Pd = /*#__PURE__*/ Xa(
/*#__PURE__*/ Mc(Rd, "_reC"));

const Kd = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ Wd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ no(ho, null, null, null, 0, "u7_0"));
}) : null;

const Td = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback$ == null || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const tp = '{display:p1.value==="fallback"&&p0.fallback$!=null&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Ad = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const qd = ({track: t, cleanup: n}) => {
    const e = ga[0], s = ga[1], o = ga[2], r = ga[3];
    const i = t(e);
    const c = ze;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Id = t => {
    if (!__EXPERIMENTAL__.pendingBoundary) {
        throw Error('Pending is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
    }
    const n = Bo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.pendingBoundary) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["pendingBoundary"]` in the `qwikVite` plugin.');
        }
        return Bo(0);
    })();
    const s = (t => {
        const n = Pf(gd, null);
        const e = Qo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Pu(/*#__PURE__*/ Mc(kd, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Kh(
    /*#__PURE__*/ Mc(Sd, "_reR", [ s ]));
    Pu(
    /*#__PURE__*/ Mc(qd, "_peT", [ e, t, n, s ]));
    const r = !ze;
    const i = r && Qd();
    const c = i ? (() => na().$.nextOutOfOrderId())() : 0;
    const l = i ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = i && sa(() => t.fallback$ != null) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Xc(Ad, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = t.fallback$ ? t.fallback$.getFn(na())() : null;
    const p = i ? /*#__PURE__*/ no(np, {
        boundary: f,
        fallbackStyle: Xc(Td, [ t, n, o, s ], tp),
        showFallback: u,
        state: n
    }, null, d, 1, null) : /*#__PURE__*/ no("div", {
        style: Xc(Td, [ t, n, o, s ], tp)
    }, null, d, 1, null);
    return [ p, 
    /*#__PURE__*/ no("div", null, i ? {
        [Ld]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ no(i ? ep : ho, i ? {
        [Hr]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Hr]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const Md = /*#__PURE__*/ Xa(
/*#__PURE__*/ Mc(Id, "_peC"));

const np = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ Wd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const r = n.varProps.fallbackStyle;
    const i = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    i && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.C(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ no("div", {
        style: r
    }, null, n.children, 1, null));
}) : null;

const ep = __EXPERIMENTAL__.pendingBoundary ? /*#__PURE__*/ Wd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const r = n.varProps.boundary;
    const i = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = __EXPERIMENTAL__.catchBoundary && e.parentComponentFrame ? t.resolveContext(e.parentComponentFrame.componentNode, Af) : void 0;
    const u = t.segment(o, function f(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            return /* @__PURE__ */ no(ho, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = R(s.componentNode, n, t);
        const r = n.children || null;
        const i = s.claimChildrenForSlot(o) || r;
        r && i !== r && t.addUnclaimedProjection(s, "", r);
        return /* @__PURE__ */ no(ho, n.varProps, n.constProps, i, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${pr}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(u.then(n => async function e(t, n, s, o, r, i) {
        if (i) {
            i.contentResolved = !0;
            if (i.delayTimer) {
                clearTimeout(i.delayTimer);
                i.delayTimer = null;
            }
        }
        r?.resolve();
        await t.C(async () => {
            t.addRoot(o);
            await Jd(t, n, s, r);
        });
    }(t, s, n, i, c, r)).catch(t => {
        if (l?.Mt) {
            return l.Mt(t);
        }
        if (l?.error !== void 0) {
            return;
        }
        throw t;
    }));
}) : null;

const xd = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = Nd.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return no("script", null, o, null, 0, "prefetch-service-worker");
};

const Nd =  "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Cd = () => null;

globalThis.__qwik && er(30, [ globalThis.__qwik, rr ]);

globalThis.__qwik = rr;

export { Ca as $, pd as Catch, wd as Each, fo as Fragment, Ef as NoSerializeSymbol, Md as Pending, Cd as PrefetchGraph, xd as PrefetchServiceWorker, ao as RenderOnce, Yc as Resource, Pd as Reveal, yo as SSRComment, $o as SSRRaw, vo as SSRStream, wo as SSRStreamBlock, Sf as SerializerSymbol, _d as Show, po as SkipRender, ho as Slot, Ui as _CONST_PROPS, Zf as _DomContainer, yi as _EFFECT_BACK_REF, Xr as _ELEMENT_SEQ, Gi as _EMPTY_ARRAY, Zi as _EMPTY_OBJ, Ji as _IMMUTABLE, Dc as _SharedContainer, Ds as _SubscriptionData, oc as _SubscriptionPatch, Au as _Task, Yi as _UNINITIALIZED, Bi as _VAR_PROPS, re as _addProjection, dd as _caC, ad as _caR, ga as _captures, m as _chk, we as _createDeserializeContainer, Ta as _createQRL, Nn as _createStore, di as _delay, $e as _deserialize, Ec as _dumpState, yd as _eaC, $d as _eaT, yn as _executeSsrChores, Xc as _fnSignal, ss as _getConstProps, aa as _getContextContainer, fa as _getContextEvent, ca as _getContextHostElement, Ie as _getDomContainer, xe as _getQContainerElement, w as _getSubscriber, is as _getVarProps, Yn as _handleSSRError, k as _hasSlotProps, Bu as _hasStoreEffects, rf as _hmr, Ps as _injectAsyncSignalValue, je as _invoke, Us as _isJSXNode, Hu as _isStore, Un as _isStringifiable, qu as _isTask, ha as _jsxBranch, ro as _jsxC, so as _jsxQ, io as _jsxS, no as _jsxSorted, eo as _jsxSplit, ii as _mapApp_findIndx, oi as _mapArray_get, si as _mapArray_set, Xu as _markSignalAsExternallyOwned, Xe as _newInvokeContext, xc as _noopQrl, Nc as _noopQrlDEV, Id as _peC, qd as _peT, Wn as _preprocessState, Fa as _qrlSync, Ln as _qrlToString, Cc as _qrlWithChunk, Oc as _qrlWithChunkDEV, Rd as _reC, Sd as _reR, kd as _reT, Fc as _regSymbol, oe as _removeProjection, b as _res, Tf as _resolveContextWithoutSequentialScope, So as _restProps, t as _retryOnPromise, Hc as _rsc, C as _run, pe as _serialize, te as _setEvent, ie as _setProjectionTarget, bd as _shC, md as _shT, Mn as _task, se as _updateProjectionProps, ee as _useHmr, v as _val, wf as _verifySerializable, Tl as _vnode_ensureElementInflated, wu as _vnode_getAttrKeys, Yl as _vnode_getElementName, Kl as _vnode_getFirstChild, El as _vnode_getProp, Cl as _vnode_getVNodeForChildNode, Ul as _vnode_insertBefore, wl as _vnode_isElementVNode, ml as _vnode_isMaterialized, bl as _vnode_isTextVNode, _l as _vnode_isVirtualVNode, $l as _vnode_newVirtual, Hl as _vnode_remove, Sl as _vnode_setProp, kn as _vnode_toString, da as _waitUntilRendered, Qn as _walkJSX, js as _wrapProp, Fs as _wrapSignal, Va as component$, Xa as componentQrl, As as createAsyncQrl, Ms as createComputed$, Ts as createComputedQrl, kf as createContextId, _ as createElement, xs as createSerializer$, qs as createSerializerQrl, Is as createSignal, za as event$, ja as eventQrl, Uu as forceStoreEffects, Ua as getClientManifest, Ie as getDomContainer, Ce as getLocale, ri as getPlatform, _ as h, Ss as implicit$FirstArg, Mc as inlinedQrl, Lc as inlinedQrlDEV, Ue as isDev, Mu as isSignal, lo as jsx, uo as jsxDEV, co as jsxs, gf as noSerialize, Ic as qrl, jc as qrlDEV, Ba as render, ei as setPlatform, La as sync$, sa as untrack, Qu as unwrapStore, td as useComputed$, Kh as useComputedQrl, Qo as useConstant, Pf as useContext, Rf as useContextProvider, Ja as useId, Qc as useLexicalScope, Zc as useOn, Kc as useOnDocument, tf as useOnWindow, ld as useResource$, Jc as useResourceQrl, rd as useSerializer$, ed as useSerializerQrl, De as useServerData, Bo as useSignal, Qa as useStore, Hh as useStyles$, Qh as useStylesQrl, Yh as useStylesScoped$, Jh as useStylesScopedQrl, ud as useTask$, Pu as useTaskQrl, cd as useVisibleTask$, id as useVisibleTaskQrl, rr as version, Oe as withLocale };
